// source: manager.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var base_pb = require('./base_pb.js');
goog.object.extend(proto, base_pb);
goog.exportSymbol('proto.manager.v1.ColumnRs', null, global);
goog.exportSymbol('proto.manager.v1.FileChunk', null, global);
goog.exportSymbol('proto.manager.v1.GenVerifyPicReply', null, global);
goog.exportSymbol('proto.manager.v1.GenVerifyPicRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManageControlPointAddRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerActiveAddRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerActiveDetailRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerActiveEditRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerActiveInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerActiveListQueryRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerActiveRule', null, global);
goog.exportSymbol('proto.manager.v1.ManagerActiveRuleEditRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerActiveRuleInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerActiveRuleListQueryRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerApkAddRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerApkEditRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerApkInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerApkListQueryRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerControlPointEditRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerControlPointImportRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerControlPointInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerControlPointListQueryReply', null, global);
goog.exportSymbol('proto.manager.v1.ManagerControlPointListQueryRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerCoursePackageAddRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerCoursePackageEditRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerCoursePackageInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerCoursePackageListQueryRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerCoursePackageRelationRouteRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerGetUserInfoReply', null, global);
goog.exportSymbol('proto.manager.v1.ManagerLocationAddRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerLocationEditRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerLocationInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerLocationListQueryRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerMapAddRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerMapEditRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerMapHistoryEditRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerMapInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerMapListQueryRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerOiInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerOiListQueryRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerPicInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerPlanAddRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerPlanCoursePackageListQueryRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerPlanEditRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerPlanInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerPlanListQueryRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerPlanRelationPackageRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerPlanSimpleInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerRole', null, global);
goog.exportSymbol('proto.manager.v1.ManagerRouteAddRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerRouteEditRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerRouteInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerRouteListQueryInPackageRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerRouteListQueryOutPackageRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerRouteListQueryRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerSignInRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerUploadInfo', null, global);
goog.exportSymbol('proto.manager.v1.ManagerUploadInfoAuditingRequest', null, global);
goog.exportSymbol('proto.manager.v1.ManagerUploadInfoListQueryRequest', null, global);
goog.exportSymbol('proto.manager.v1.StdRsReply', null, global);
goog.exportSymbol('proto.manager.v1.columnMeta', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerUploadInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerUploadInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerUploadInfo.displayName = 'proto.manager.v1.ManagerUploadInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerUploadInfoAuditingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerUploadInfoAuditingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerUploadInfoAuditingRequest.displayName = 'proto.manager.v1.ManagerUploadInfoAuditingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerActiveRuleEditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerActiveRuleEditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerActiveRuleEditRequest.displayName = 'proto.manager.v1.ManagerActiveRuleEditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerPlanCoursePackageListQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.displayName = 'proto.manager.v1.ManagerPlanCoursePackageListQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerPlanRelationPackageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manager.v1.ManagerPlanRelationPackageRequest.repeatedFields_, null);
};
goog.inherits(proto.manager.v1.ManagerPlanRelationPackageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerPlanRelationPackageRequest.displayName = 'proto.manager.v1.ManagerPlanRelationPackageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerActiveDetailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerActiveDetailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerActiveDetailRequest.displayName = 'proto.manager.v1.ManagerActiveDetailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerUploadInfoListQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerUploadInfoListQueryRequest.displayName = 'proto.manager.v1.ManagerUploadInfoListQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerPicInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerPicInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerPicInfo.displayName = 'proto.manager.v1.ManagerPicInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManageControlPointAddRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManageControlPointAddRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManageControlPointAddRequest.displayName = 'proto.manager.v1.ManageControlPointAddRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerControlPointEditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerControlPointEditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerControlPointEditRequest.displayName = 'proto.manager.v1.ManagerControlPointEditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerGetUserInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manager.v1.ManagerGetUserInfoReply.repeatedFields_, null);
};
goog.inherits(proto.manager.v1.ManagerGetUserInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerGetUserInfoReply.displayName = 'proto.manager.v1.ManagerGetUserInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerRole = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerRole, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerRole.displayName = 'proto.manager.v1.ManagerRole';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ColumnRs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manager.v1.ColumnRs.repeatedFields_, null);
};
goog.inherits(proto.manager.v1.ColumnRs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ColumnRs.displayName = 'proto.manager.v1.ColumnRs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.columnMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.columnMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.columnMeta.displayName = 'proto.manager.v1.columnMeta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerApkListQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerApkListQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerApkListQueryRequest.displayName = 'proto.manager.v1.ManagerApkListQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerApkInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerApkInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerApkInfo.displayName = 'proto.manager.v1.ManagerApkInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerApkAddRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerApkAddRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerApkAddRequest.displayName = 'proto.manager.v1.ManagerApkAddRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerApkEditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerApkEditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerApkEditRequest.displayName = 'proto.manager.v1.ManagerApkEditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.FileChunk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.FileChunk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.FileChunk.displayName = 'proto.manager.v1.FileChunk';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerLocationListQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerLocationListQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerLocationListQueryRequest.displayName = 'proto.manager.v1.ManagerLocationListQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerLocationInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerLocationInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerLocationInfo.displayName = 'proto.manager.v1.ManagerLocationInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerLocationAddRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerLocationAddRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerLocationAddRequest.displayName = 'proto.manager.v1.ManagerLocationAddRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerLocationEditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerLocationEditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerLocationEditRequest.displayName = 'proto.manager.v1.ManagerLocationEditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerMapListQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerMapListQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerMapListQueryRequest.displayName = 'proto.manager.v1.ManagerMapListQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerMapInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerMapInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerMapInfo.displayName = 'proto.manager.v1.ManagerMapInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerMapAddRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerMapAddRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerMapAddRequest.displayName = 'proto.manager.v1.ManagerMapAddRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerMapEditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerMapEditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerMapEditRequest.displayName = 'proto.manager.v1.ManagerMapEditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerMapHistoryEditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerMapHistoryEditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerMapHistoryEditRequest.displayName = 'proto.manager.v1.ManagerMapHistoryEditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerControlPointImportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerControlPointImportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerControlPointImportRequest.displayName = 'proto.manager.v1.ManagerControlPointImportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerControlPointListQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerControlPointListQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerControlPointListQueryRequest.displayName = 'proto.manager.v1.ManagerControlPointListQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerControlPointListQueryReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manager.v1.ManagerControlPointListQueryReply.repeatedFields_, null);
};
goog.inherits(proto.manager.v1.ManagerControlPointListQueryReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerControlPointListQueryReply.displayName = 'proto.manager.v1.ManagerControlPointListQueryReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerControlPointInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerControlPointInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerControlPointInfo.displayName = 'proto.manager.v1.ManagerControlPointInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerRouteListQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerRouteListQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerRouteListQueryRequest.displayName = 'proto.manager.v1.ManagerRouteListQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerRouteListQueryInPackageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerRouteListQueryInPackageRequest.displayName = 'proto.manager.v1.ManagerRouteListQueryInPackageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerRouteListQueryOutPackageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerRouteListQueryOutPackageRequest.displayName = 'proto.manager.v1.ManagerRouteListQueryOutPackageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerRouteInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerRouteInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerRouteInfo.displayName = 'proto.manager.v1.ManagerRouteInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerRouteAddRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerRouteAddRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerRouteAddRequest.displayName = 'proto.manager.v1.ManagerRouteAddRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerRouteEditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerRouteEditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerRouteEditRequest.displayName = 'proto.manager.v1.ManagerRouteEditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerCoursePackageListQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerCoursePackageListQueryRequest.displayName = 'proto.manager.v1.ManagerCoursePackageListQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerCoursePackageInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerCoursePackageInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerCoursePackageInfo.displayName = 'proto.manager.v1.ManagerCoursePackageInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerCoursePackageAddRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerCoursePackageAddRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerCoursePackageAddRequest.displayName = 'proto.manager.v1.ManagerCoursePackageAddRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerCoursePackageEditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerCoursePackageEditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerCoursePackageEditRequest.displayName = 'proto.manager.v1.ManagerCoursePackageEditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manager.v1.ManagerCoursePackageRelationRouteRequest.repeatedFields_, null);
};
goog.inherits(proto.manager.v1.ManagerCoursePackageRelationRouteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerCoursePackageRelationRouteRequest.displayName = 'proto.manager.v1.ManagerCoursePackageRelationRouteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.GenVerifyPicRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.GenVerifyPicRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.GenVerifyPicRequest.displayName = 'proto.manager.v1.GenVerifyPicRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.StdRsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.StdRsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.StdRsReply.displayName = 'proto.manager.v1.StdRsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerOiListQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerOiListQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerOiListQueryRequest.displayName = 'proto.manager.v1.ManagerOiListQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerOiInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerOiInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerOiInfo.displayName = 'proto.manager.v1.ManagerOiInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerActiveListQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerActiveListQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerActiveListQueryRequest.displayName = 'proto.manager.v1.ManagerActiveListQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerActiveRuleListQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerActiveRuleListQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerActiveRuleListQueryRequest.displayName = 'proto.manager.v1.ManagerActiveRuleListQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerActiveRuleInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerActiveRuleInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerActiveRuleInfo.displayName = 'proto.manager.v1.ManagerActiveRuleInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerActiveInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerActiveInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerActiveInfo.displayName = 'proto.manager.v1.ManagerActiveInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerActiveRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerActiveRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerActiveRule.displayName = 'proto.manager.v1.ManagerActiveRule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerActiveAddRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerActiveAddRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerActiveAddRequest.displayName = 'proto.manager.v1.ManagerActiveAddRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerActiveEditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerActiveEditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerActiveEditRequest.displayName = 'proto.manager.v1.ManagerActiveEditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerPlanListQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerPlanListQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerPlanListQueryRequest.displayName = 'proto.manager.v1.ManagerPlanListQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerPlanInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manager.v1.ManagerPlanInfo.repeatedFields_, null);
};
goog.inherits(proto.manager.v1.ManagerPlanInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerPlanInfo.displayName = 'proto.manager.v1.ManagerPlanInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerPlanSimpleInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerPlanSimpleInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerPlanSimpleInfo.displayName = 'proto.manager.v1.ManagerPlanSimpleInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerPlanAddRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manager.v1.ManagerPlanAddRequest.repeatedFields_, null);
};
goog.inherits(proto.manager.v1.ManagerPlanAddRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerPlanAddRequest.displayName = 'proto.manager.v1.ManagerPlanAddRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerPlanEditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manager.v1.ManagerPlanEditRequest.repeatedFields_, null);
};
goog.inherits(proto.manager.v1.ManagerPlanEditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerPlanEditRequest.displayName = 'proto.manager.v1.ManagerPlanEditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.GenVerifyPicReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.GenVerifyPicReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.GenVerifyPicReply.displayName = 'proto.manager.v1.GenVerifyPicReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.manager.v1.ManagerSignInRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.manager.v1.ManagerSignInRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manager.v1.ManagerSignInRequest.displayName = 'proto.manager.v1.ManagerSignInRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerUploadInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerUploadInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerUploadInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerUploadInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
mouid: jspb.Message.getFieldWithDefault(msg, 1, 0),
uptype: jspb.Message.getFieldWithDefault(msg, 2, 0),
upval: jspb.Message.getFieldWithDefault(msg, 3, ""),
reviewtype: jspb.Message.getFieldWithDefault(msg, 4, 0),
createdat: jspb.Message.getFieldWithDefault(msg, 5, ""),
reviewtime: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerUploadInfo}
 */
proto.manager.v1.ManagerUploadInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerUploadInfo;
  return proto.manager.v1.ManagerUploadInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerUploadInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerUploadInfo}
 */
proto.manager.v1.ManagerUploadInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMouid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUptype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpval(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReviewtype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedat(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setReviewtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerUploadInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerUploadInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerUploadInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerUploadInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMouid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUptype();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getUpval();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReviewtype();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCreatedat();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getReviewtime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 mouId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerUploadInfo.prototype.getMouid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerUploadInfo} returns this
 */
proto.manager.v1.ManagerUploadInfo.prototype.setMouid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 upType = 2;
 * @return {number}
 */
proto.manager.v1.ManagerUploadInfo.prototype.getUptype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerUploadInfo} returns this
 */
proto.manager.v1.ManagerUploadInfo.prototype.setUptype = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string upVal = 3;
 * @return {string}
 */
proto.manager.v1.ManagerUploadInfo.prototype.getUpval = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerUploadInfo} returns this
 */
proto.manager.v1.ManagerUploadInfo.prototype.setUpval = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 reviewType = 4;
 * @return {number}
 */
proto.manager.v1.ManagerUploadInfo.prototype.getReviewtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerUploadInfo} returns this
 */
proto.manager.v1.ManagerUploadInfo.prototype.setReviewtype = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string createdAt = 5;
 * @return {string}
 */
proto.manager.v1.ManagerUploadInfo.prototype.getCreatedat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerUploadInfo} returns this
 */
proto.manager.v1.ManagerUploadInfo.prototype.setCreatedat = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string reviewTime = 6;
 * @return {string}
 */
proto.manager.v1.ManagerUploadInfo.prototype.getReviewtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerUploadInfo} returns this
 */
proto.manager.v1.ManagerUploadInfo.prototype.setReviewtime = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerUploadInfoAuditingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerUploadInfoAuditingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerUploadInfoAuditingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerUploadInfoAuditingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
mouid: jspb.Message.getFieldWithDefault(msg, 1, 0),
isreview: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerUploadInfoAuditingRequest}
 */
proto.manager.v1.ManagerUploadInfoAuditingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerUploadInfoAuditingRequest;
  return proto.manager.v1.ManagerUploadInfoAuditingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerUploadInfoAuditingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerUploadInfoAuditingRequest}
 */
proto.manager.v1.ManagerUploadInfoAuditingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMouid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerUploadInfoAuditingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerUploadInfoAuditingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerUploadInfoAuditingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerUploadInfoAuditingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMouid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIsreview();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 mouId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerUploadInfoAuditingRequest.prototype.getMouid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerUploadInfoAuditingRequest} returns this
 */
proto.manager.v1.ManagerUploadInfoAuditingRequest.prototype.setMouid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 isReview = 2;
 * @return {number}
 */
proto.manager.v1.ManagerUploadInfoAuditingRequest.prototype.getIsreview = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerUploadInfoAuditingRequest} returns this
 */
proto.manager.v1.ManagerUploadInfoAuditingRequest.prototype.setIsreview = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerActiveRuleEditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerActiveRuleEditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerActiveRuleEditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveRuleEditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
arrid: jspb.Message.getFieldWithDefault(msg, 1, 0),
arvalue: jspb.Message.getFieldWithDefault(msg, 2, ""),
islock: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
tolock: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
toislockedit: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerActiveRuleEditRequest}
 */
proto.manager.v1.ManagerActiveRuleEditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerActiveRuleEditRequest;
  return proto.manager.v1.ManagerActiveRuleEditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerActiveRuleEditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerActiveRuleEditRequest}
 */
proto.manager.v1.ManagerActiveRuleEditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArrid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setArvalue(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIslock(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTolock(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setToislockedit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerActiveRuleEditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerActiveRuleEditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerActiveRuleEditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveRuleEditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArrid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getArvalue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIslock();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTolock();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getToislockedit();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional int32 arrId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerActiveRuleEditRequest.prototype.getArrid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveRuleEditRequest} returns this
 */
proto.manager.v1.ManagerActiveRuleEditRequest.prototype.setArrid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string arValue = 2;
 * @return {string}
 */
proto.manager.v1.ManagerActiveRuleEditRequest.prototype.getArvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveRuleEditRequest} returns this
 */
proto.manager.v1.ManagerActiveRuleEditRequest.prototype.setArvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool isLock = 3;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveRuleEditRequest.prototype.getIslock = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveRuleEditRequest} returns this
 */
proto.manager.v1.ManagerActiveRuleEditRequest.prototype.setIslock = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool toLock = 4;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveRuleEditRequest.prototype.getTolock = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveRuleEditRequest} returns this
 */
proto.manager.v1.ManagerActiveRuleEditRequest.prototype.setTolock = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool toIsLockEdit = 5;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveRuleEditRequest.prototype.getToislockedit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveRuleEditRequest} returns this
 */
proto.manager.v1.ManagerActiveRuleEditRequest.prototype.setToislockedit = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerPlanCoursePackageListQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
planid: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerPlanCoursePackageListQueryRequest}
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerPlanCoursePackageListQueryRequest;
  return proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerPlanCoursePackageListQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerPlanCoursePackageListQueryRequest}
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlanid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerPlanCoursePackageListQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlanid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 planId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.prototype.getPlanid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanCoursePackageListQueryRequest} returns this
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.prototype.setPlanid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanCoursePackageListQueryRequest} returns this
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 tableMax = 3;
 * @return {number}
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanCoursePackageListQueryRequest} returns this
 */
proto.manager.v1.ManagerPlanCoursePackageListQueryRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerPlanRelationPackageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerPlanRelationPackageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
planid: jspb.Message.getFieldWithDefault(msg, 1, 0),
packageidarrList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerPlanRelationPackageRequest}
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerPlanRelationPackageRequest;
  return proto.manager.v1.ManagerPlanRelationPackageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerPlanRelationPackageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerPlanRelationPackageRequest}
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlanid(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPackageidarr(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerPlanRelationPackageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerPlanRelationPackageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlanid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPackageidarrList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 planId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.prototype.getPlanid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanRelationPackageRequest} returns this
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.prototype.setPlanid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated int32 packageIdArr = 2;
 * @return {!Array<number>}
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.prototype.getPackageidarrList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.manager.v1.ManagerPlanRelationPackageRequest} returns this
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.prototype.setPackageidarrList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.manager.v1.ManagerPlanRelationPackageRequest} returns this
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.prototype.addPackageidarr = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.manager.v1.ManagerPlanRelationPackageRequest} returns this
 */
proto.manager.v1.ManagerPlanRelationPackageRequest.prototype.clearPackageidarrList = function() {
  return this.setPackageidarrList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerActiveDetailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerActiveDetailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerActiveDetailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveDetailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
actid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerActiveDetailRequest}
 */
proto.manager.v1.ManagerActiveDetailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerActiveDetailRequest;
  return proto.manager.v1.ManagerActiveDetailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerActiveDetailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerActiveDetailRequest}
 */
proto.manager.v1.ManagerActiveDetailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerActiveDetailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerActiveDetailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerActiveDetailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveDetailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 actId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerActiveDetailRequest.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveDetailRequest} returns this
 */
proto.manager.v1.ManagerActiveDetailRequest.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerUploadInfoListQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerUploadInfoListQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uptype: jspb.Message.getFieldWithDefault(msg, 1, 0),
isreview: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerUploadInfoListQueryRequest}
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerUploadInfoListQueryRequest;
  return proto.manager.v1.ManagerUploadInfoListQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerUploadInfoListQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerUploadInfoListQueryRequest}
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUptype(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsreview(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerUploadInfoListQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerUploadInfoListQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUptype();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIsreview();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 upType = 1;
 * @return {number}
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.prototype.getUptype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerUploadInfoListQueryRequest} returns this
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.prototype.setUptype = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 isReview = 2;
 * @return {number}
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.prototype.getIsreview = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerUploadInfoListQueryRequest} returns this
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.prototype.setIsreview = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerUploadInfoListQueryRequest} returns this
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 tableMax = 4;
 * @return {number}
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerUploadInfoListQueryRequest} returns this
 */
proto.manager.v1.ManagerUploadInfoListQueryRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerPicInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerPicInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerPicInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPicInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
picid: jspb.Message.getFieldWithDefault(msg, 1, 0),
piccontent: jspb.Message.getFieldWithDefault(msg, 2, ""),
url: jspb.Message.getFieldWithDefault(msg, 3, ""),
md5: jspb.Message.getFieldWithDefault(msg, 4, ""),
status: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerPicInfo}
 */
proto.manager.v1.ManagerPicInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerPicInfo;
  return proto.manager.v1.ManagerPicInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerPicInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerPicInfo}
 */
proto.manager.v1.ManagerPicInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPicid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPiccontent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMd5(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerPicInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerPicInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerPicInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPicInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPicid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPiccontent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMd5();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 picId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerPicInfo.prototype.getPicid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPicInfo} returns this
 */
proto.manager.v1.ManagerPicInfo.prototype.setPicid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string picContent = 2;
 * @return {string}
 */
proto.manager.v1.ManagerPicInfo.prototype.getPiccontent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPicInfo} returns this
 */
proto.manager.v1.ManagerPicInfo.prototype.setPiccontent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.manager.v1.ManagerPicInfo.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPicInfo} returns this
 */
proto.manager.v1.ManagerPicInfo.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string md5 = 4;
 * @return {string}
 */
proto.manager.v1.ManagerPicInfo.prototype.getMd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPicInfo} returns this
 */
proto.manager.v1.ManagerPicInfo.prototype.setMd5 = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 status = 5;
 * @return {number}
 */
proto.manager.v1.ManagerPicInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPicInfo} returns this
 */
proto.manager.v1.ManagerPicInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManageControlPointAddRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManageControlPointAddRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManageControlPointAddRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
cicode: jspb.Message.getFieldWithDefault(msg, 2, ""),
cdescription: jspb.Message.getFieldWithDefault(msg, 3, ""),
isbegin: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManageControlPointAddRequest}
 */
proto.manager.v1.ManageControlPointAddRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManageControlPointAddRequest;
  return proto.manager.v1.ManageControlPointAddRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManageControlPointAddRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManageControlPointAddRequest}
 */
proto.manager.v1.ManageControlPointAddRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCicode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCdescription(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsbegin(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManageControlPointAddRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManageControlPointAddRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManageControlPointAddRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCicode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCdescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsbegin();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManageControlPointAddRequest} returns this
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ciCode = 2;
 * @return {string}
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.getCicode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManageControlPointAddRequest} returns this
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.setCicode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string cDescription = 3;
 * @return {string}
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.getCdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManageControlPointAddRequest} returns this
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.setCdescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool isBegin = 4;
 * @return {boolean}
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.getIsbegin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManageControlPointAddRequest} returns this
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.setIsbegin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional double longitude = 5;
 * @return {number}
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManageControlPointAddRequest} returns this
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double latitude = 6;
 * @return {number}
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManageControlPointAddRequest} returns this
 */
proto.manager.v1.ManageControlPointAddRequest.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerControlPointEditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerControlPointEditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerControlPointEditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
cpid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapid: jspb.Message.getFieldWithDefault(msg, 2, 0),
cicode: jspb.Message.getFieldWithDefault(msg, 3, ""),
cdescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
isbegin: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerControlPointEditRequest}
 */
proto.manager.v1.ManagerControlPointEditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerControlPointEditRequest;
  return proto.manager.v1.ManagerControlPointEditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerControlPointEditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerControlPointEditRequest}
 */
proto.manager.v1.ManagerControlPointEditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCpid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCicode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCdescription(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsbegin(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerControlPointEditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerControlPointEditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerControlPointEditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCpid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCicode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCdescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIsbegin();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
};


/**
 * optional int32 cpId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.getCpid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointEditRequest} returns this
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.setCpid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 mapId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointEditRequest} returns this
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string ciCode = 3;
 * @return {string}
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.getCicode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerControlPointEditRequest} returns this
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.setCicode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string cDescription = 4;
 * @return {string}
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.getCdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerControlPointEditRequest} returns this
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.setCdescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool isBegin = 5;
 * @return {boolean}
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.getIsbegin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerControlPointEditRequest} returns this
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.setIsbegin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional double longitude = 6;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointEditRequest} returns this
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double latitude = 7;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointEditRequest} returns this
 */
proto.manager.v1.ManagerControlPointEditRequest.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.manager.v1.ManagerGetUserInfoReply.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerGetUserInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerGetUserInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerGetUserInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerGetUserInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
username: jspb.Message.getFieldWithDefault(msg, 2, ""),
rolesList: jspb.Message.toObjectList(msg.getRolesList(),
    proto.manager.v1.ManagerRole.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerGetUserInfoReply}
 */
proto.manager.v1.ManagerGetUserInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerGetUserInfoReply;
  return proto.manager.v1.ManagerGetUserInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerGetUserInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerGetUserInfoReply}
 */
proto.manager.v1.ManagerGetUserInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = new proto.manager.v1.ManagerRole;
      reader.readMessage(value,proto.manager.v1.ManagerRole.deserializeBinaryFromReader);
      msg.addRoles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerGetUserInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerGetUserInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerGetUserInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerGetUserInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.manager.v1.ManagerRole.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.manager.v1.ManagerGetUserInfoReply.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerGetUserInfoReply} returns this
 */
proto.manager.v1.ManagerGetUserInfoReply.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.manager.v1.ManagerGetUserInfoReply.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerGetUserInfoReply} returns this
 */
proto.manager.v1.ManagerGetUserInfoReply.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ManagerRole roles = 3;
 * @return {!Array<!proto.manager.v1.ManagerRole>}
 */
proto.manager.v1.ManagerGetUserInfoReply.prototype.getRolesList = function() {
  return /** @type{!Array<!proto.manager.v1.ManagerRole>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.manager.v1.ManagerRole, 3));
};


/**
 * @param {!Array<!proto.manager.v1.ManagerRole>} value
 * @return {!proto.manager.v1.ManagerGetUserInfoReply} returns this
*/
proto.manager.v1.ManagerGetUserInfoReply.prototype.setRolesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.manager.v1.ManagerRole=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manager.v1.ManagerRole}
 */
proto.manager.v1.ManagerGetUserInfoReply.prototype.addRoles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.manager.v1.ManagerRole, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.manager.v1.ManagerGetUserInfoReply} returns this
 */
proto.manager.v1.ManagerGetUserInfoReply.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerRole.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerRole.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerRole} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRole.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerRole}
 */
proto.manager.v1.ManagerRole.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerRole;
  return proto.manager.v1.ManagerRole.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerRole} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerRole}
 */
proto.manager.v1.ManagerRole.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerRole.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerRole.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerRole} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRole.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.manager.v1.ManagerRole.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRole} returns this
 */
proto.manager.v1.ManagerRole.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.manager.v1.ManagerRole.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerRole} returns this
 */
proto.manager.v1.ManagerRole.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.manager.v1.ColumnRs.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ColumnRs.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ColumnRs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ColumnRs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ColumnRs.toObject = function(includeInstance, msg) {
  var f, obj = {
clid: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
path: jspb.Message.getFieldWithDefault(msg, 3, ""),
component: jspb.Message.getFieldWithDefault(msg, 4, ""),
redirect: jspb.Message.getFieldWithDefault(msg, 5, ""),
meta: (f = msg.getMeta()) && proto.manager.v1.columnMeta.toObject(includeInstance, f),
hidden: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
childrenList: jspb.Message.toObjectList(msg.getChildrenList(),
    proto.manager.v1.ColumnRs.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ColumnRs}
 */
proto.manager.v1.ColumnRs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ColumnRs;
  return proto.manager.v1.ColumnRs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ColumnRs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ColumnRs}
 */
proto.manager.v1.ColumnRs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setComponent(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirect(value);
      break;
    case 6:
      var value = new proto.manager.v1.columnMeta;
      reader.readMessage(value,proto.manager.v1.columnMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    case 8:
      var value = new proto.manager.v1.ColumnRs;
      reader.readMessage(value,proto.manager.v1.ColumnRs.deserializeBinaryFromReader);
      msg.addChildren(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ColumnRs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ColumnRs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ColumnRs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ColumnRs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getComponent();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRedirect();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.manager.v1.columnMeta.serializeBinaryToWriter
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.manager.v1.ColumnRs.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 clId = 1;
 * @return {number}
 */
proto.manager.v1.ColumnRs.prototype.getClid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ColumnRs} returns this
 */
proto.manager.v1.ColumnRs.prototype.setClid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.manager.v1.ColumnRs.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ColumnRs} returns this
 */
proto.manager.v1.ColumnRs.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string path = 3;
 * @return {string}
 */
proto.manager.v1.ColumnRs.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ColumnRs} returns this
 */
proto.manager.v1.ColumnRs.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string component = 4;
 * @return {string}
 */
proto.manager.v1.ColumnRs.prototype.getComponent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ColumnRs} returns this
 */
proto.manager.v1.ColumnRs.prototype.setComponent = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string redirect = 5;
 * @return {string}
 */
proto.manager.v1.ColumnRs.prototype.getRedirect = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ColumnRs} returns this
 */
proto.manager.v1.ColumnRs.prototype.setRedirect = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional columnMeta meta = 6;
 * @return {?proto.manager.v1.columnMeta}
 */
proto.manager.v1.ColumnRs.prototype.getMeta = function() {
  return /** @type{?proto.manager.v1.columnMeta} */ (
    jspb.Message.getWrapperField(this, proto.manager.v1.columnMeta, 6));
};


/**
 * @param {?proto.manager.v1.columnMeta|undefined} value
 * @return {!proto.manager.v1.ColumnRs} returns this
*/
proto.manager.v1.ColumnRs.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ColumnRs} returns this
 */
proto.manager.v1.ColumnRs.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ColumnRs.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool hidden = 7;
 * @return {boolean}
 */
proto.manager.v1.ColumnRs.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ColumnRs} returns this
 */
proto.manager.v1.ColumnRs.prototype.setHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * repeated ColumnRs children = 8;
 * @return {!Array<!proto.manager.v1.ColumnRs>}
 */
proto.manager.v1.ColumnRs.prototype.getChildrenList = function() {
  return /** @type{!Array<!proto.manager.v1.ColumnRs>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.manager.v1.ColumnRs, 8));
};


/**
 * @param {!Array<!proto.manager.v1.ColumnRs>} value
 * @return {!proto.manager.v1.ColumnRs} returns this
*/
proto.manager.v1.ColumnRs.prototype.setChildrenList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.manager.v1.ColumnRs=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manager.v1.ColumnRs}
 */
proto.manager.v1.ColumnRs.prototype.addChildren = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.manager.v1.ColumnRs, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.manager.v1.ColumnRs} returns this
 */
proto.manager.v1.ColumnRs.prototype.clearChildrenList = function() {
  return this.setChildrenList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.columnMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.columnMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.columnMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.columnMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
icon: jspb.Message.getFieldWithDefault(msg, 2, ""),
roles: jspb.Message.getFieldWithDefault(msg, 3, ""),
breadcrumb: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.columnMeta}
 */
proto.manager.v1.columnMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.columnMeta;
  return proto.manager.v1.columnMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.columnMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.columnMeta}
 */
proto.manager.v1.columnMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoles(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBreadcrumb(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.columnMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.columnMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.columnMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.columnMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoles();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBreadcrumb();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.manager.v1.columnMeta.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.columnMeta} returns this
 */
proto.manager.v1.columnMeta.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string icon = 2;
 * @return {string}
 */
proto.manager.v1.columnMeta.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.columnMeta} returns this
 */
proto.manager.v1.columnMeta.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string roles = 3;
 * @return {string}
 */
proto.manager.v1.columnMeta.prototype.getRoles = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.columnMeta} returns this
 */
proto.manager.v1.columnMeta.prototype.setRoles = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool breadcrumb = 4;
 * @return {boolean}
 */
proto.manager.v1.columnMeta.prototype.getBreadcrumb = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.columnMeta} returns this
 */
proto.manager.v1.columnMeta.prototype.setBreadcrumb = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerApkListQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerApkListQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerApkListQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerApkListQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 2, 0),
vtype: jspb.Message.getFieldWithDefault(msg, 3, 0),
vcode: jspb.Message.getFieldWithDefault(msg, 4, ""),
vshop: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerApkListQueryRequest}
 */
proto.manager.v1.ManagerApkListQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerApkListQueryRequest;
  return proto.manager.v1.ManagerApkListQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerApkListQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerApkListQueryRequest}
 */
proto.manager.v1.ManagerApkListQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVtype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVcode(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVshop(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerApkListQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerApkListQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerApkListQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerApkListQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getVtype();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getVcode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVshop();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.manager.v1.ManagerApkListQueryRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkListQueryRequest} returns this
 */
proto.manager.v1.ManagerApkListQueryRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 tableMax = 2;
 * @return {number}
 */
proto.manager.v1.ManagerApkListQueryRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkListQueryRequest} returns this
 */
proto.manager.v1.ManagerApkListQueryRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 vType = 3;
 * @return {number}
 */
proto.manager.v1.ManagerApkListQueryRequest.prototype.getVtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkListQueryRequest} returns this
 */
proto.manager.v1.ManagerApkListQueryRequest.prototype.setVtype = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string vCode = 4;
 * @return {string}
 */
proto.manager.v1.ManagerApkListQueryRequest.prototype.getVcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerApkListQueryRequest} returns this
 */
proto.manager.v1.ManagerApkListQueryRequest.prototype.setVcode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 vShop = 5;
 * @return {number}
 */
proto.manager.v1.ManagerApkListQueryRequest.prototype.getVshop = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkListQueryRequest} returns this
 */
proto.manager.v1.ManagerApkListQueryRequest.prototype.setVshop = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerApkInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerApkInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerApkInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerApkInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
vid: jspb.Message.getFieldWithDefault(msg, 1, 0),
vcode: jspb.Message.getFieldWithDefault(msg, 2, ""),
vurl: jspb.Message.getFieldWithDefault(msg, 3, ""),
vmemo: jspb.Message.getFieldWithDefault(msg, 4, ""),
vnum: jspb.Message.getFieldWithDefault(msg, 5, 0),
status: jspb.Message.getFieldWithDefault(msg, 6, 0),
vtype: jspb.Message.getFieldWithDefault(msg, 7, 0),
createdtime: jspb.Message.getFieldWithDefault(msg, 8, ""),
vshop: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerApkInfo}
 */
proto.manager.v1.ManagerApkInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerApkInfo;
  return proto.manager.v1.ManagerApkInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerApkInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerApkInfo}
 */
proto.manager.v1.ManagerApkInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVcode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVurl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVmemo(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVnum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVtype(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedtime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVshop(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerApkInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerApkInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerApkInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerApkInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVcode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVurl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVmemo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVnum();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getVtype();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getCreatedtime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getVshop();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional int32 vId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerApkInfo.prototype.getVid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkInfo} returns this
 */
proto.manager.v1.ManagerApkInfo.prototype.setVid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string vCode = 2;
 * @return {string}
 */
proto.manager.v1.ManagerApkInfo.prototype.getVcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerApkInfo} returns this
 */
proto.manager.v1.ManagerApkInfo.prototype.setVcode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string vUrl = 3;
 * @return {string}
 */
proto.manager.v1.ManagerApkInfo.prototype.getVurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerApkInfo} returns this
 */
proto.manager.v1.ManagerApkInfo.prototype.setVurl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string vMemo = 4;
 * @return {string}
 */
proto.manager.v1.ManagerApkInfo.prototype.getVmemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerApkInfo} returns this
 */
proto.manager.v1.ManagerApkInfo.prototype.setVmemo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 vNum = 5;
 * @return {number}
 */
proto.manager.v1.ManagerApkInfo.prototype.getVnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkInfo} returns this
 */
proto.manager.v1.ManagerApkInfo.prototype.setVnum = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 status = 6;
 * @return {number}
 */
proto.manager.v1.ManagerApkInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkInfo} returns this
 */
proto.manager.v1.ManagerApkInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 vType = 7;
 * @return {number}
 */
proto.manager.v1.ManagerApkInfo.prototype.getVtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkInfo} returns this
 */
proto.manager.v1.ManagerApkInfo.prototype.setVtype = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string createdTime = 8;
 * @return {string}
 */
proto.manager.v1.ManagerApkInfo.prototype.getCreatedtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerApkInfo} returns this
 */
proto.manager.v1.ManagerApkInfo.prototype.setCreatedtime = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 vShop = 9;
 * @return {number}
 */
proto.manager.v1.ManagerApkInfo.prototype.getVshop = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkInfo} returns this
 */
proto.manager.v1.ManagerApkInfo.prototype.setVshop = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerApkAddRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerApkAddRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerApkAddRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerApkAddRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
vcode: jspb.Message.getFieldWithDefault(msg, 1, ""),
vmemo: jspb.Message.getFieldWithDefault(msg, 2, ""),
vtype: jspb.Message.getFieldWithDefault(msg, 3, 0),
vshop: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerApkAddRequest}
 */
proto.manager.v1.ManagerApkAddRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerApkAddRequest;
  return proto.manager.v1.ManagerApkAddRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerApkAddRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerApkAddRequest}
 */
proto.manager.v1.ManagerApkAddRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVcode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVmemo(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVtype(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVshop(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerApkAddRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerApkAddRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerApkAddRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerApkAddRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVcode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVmemo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVtype();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getVshop();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string vCode = 1;
 * @return {string}
 */
proto.manager.v1.ManagerApkAddRequest.prototype.getVcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerApkAddRequest} returns this
 */
proto.manager.v1.ManagerApkAddRequest.prototype.setVcode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vMemo = 2;
 * @return {string}
 */
proto.manager.v1.ManagerApkAddRequest.prototype.getVmemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerApkAddRequest} returns this
 */
proto.manager.v1.ManagerApkAddRequest.prototype.setVmemo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 vType = 3;
 * @return {number}
 */
proto.manager.v1.ManagerApkAddRequest.prototype.getVtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkAddRequest} returns this
 */
proto.manager.v1.ManagerApkAddRequest.prototype.setVtype = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 vShop = 4;
 * @return {number}
 */
proto.manager.v1.ManagerApkAddRequest.prototype.getVshop = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkAddRequest} returns this
 */
proto.manager.v1.ManagerApkAddRequest.prototype.setVshop = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerApkEditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerApkEditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerApkEditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerApkEditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
vid: jspb.Message.getFieldWithDefault(msg, 1, 0),
vcode: jspb.Message.getFieldWithDefault(msg, 2, ""),
vmemo: jspb.Message.getFieldWithDefault(msg, 3, ""),
vtype: jspb.Message.getFieldWithDefault(msg, 4, 0),
vshop: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerApkEditRequest}
 */
proto.manager.v1.ManagerApkEditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerApkEditRequest;
  return proto.manager.v1.ManagerApkEditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerApkEditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerApkEditRequest}
 */
proto.manager.v1.ManagerApkEditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVcode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVmemo(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVtype(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVshop(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerApkEditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerApkEditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerApkEditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerApkEditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVcode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVmemo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVtype();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getVshop();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 vId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerApkEditRequest.prototype.getVid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkEditRequest} returns this
 */
proto.manager.v1.ManagerApkEditRequest.prototype.setVid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string vCode = 2;
 * @return {string}
 */
proto.manager.v1.ManagerApkEditRequest.prototype.getVcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerApkEditRequest} returns this
 */
proto.manager.v1.ManagerApkEditRequest.prototype.setVcode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string vMemo = 3;
 * @return {string}
 */
proto.manager.v1.ManagerApkEditRequest.prototype.getVmemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerApkEditRequest} returns this
 */
proto.manager.v1.ManagerApkEditRequest.prototype.setVmemo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 vType = 4;
 * @return {number}
 */
proto.manager.v1.ManagerApkEditRequest.prototype.getVtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkEditRequest} returns this
 */
proto.manager.v1.ManagerApkEditRequest.prototype.setVtype = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 vShop = 5;
 * @return {number}
 */
proto.manager.v1.ManagerApkEditRequest.prototype.getVshop = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerApkEditRequest} returns this
 */
proto.manager.v1.ManagerApkEditRequest.prototype.setVshop = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.FileChunk.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.FileChunk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.FileChunk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.FileChunk.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.FileChunk}
 */
proto.manager.v1.FileChunk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.FileChunk;
  return proto.manager.v1.FileChunk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.FileChunk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.FileChunk}
 */
proto.manager.v1.FileChunk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.FileChunk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.FileChunk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.FileChunk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.FileChunk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.manager.v1.FileChunk.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.FileChunk} returns this
 */
proto.manager.v1.FileChunk.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string fileName = 2;
 * @return {string}
 */
proto.manager.v1.FileChunk.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.FileChunk} returns this
 */
proto.manager.v1.FileChunk.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes data = 3;
 * @return {string}
 */
proto.manager.v1.FileChunk.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes data = 3;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.manager.v1.FileChunk.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.manager.v1.FileChunk.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.manager.v1.FileChunk} returns this
 */
proto.manager.v1.FileChunk.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerLocationListQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerLocationListQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerLocationListQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerLocationListQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
lname: jspb.Message.getFieldWithDefault(msg, 1, ""),
regionid: jspb.Message.getFieldWithDefault(msg, 2, ""),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerLocationListQueryRequest}
 */
proto.manager.v1.ManagerLocationListQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerLocationListQueryRequest;
  return proto.manager.v1.ManagerLocationListQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerLocationListQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerLocationListQueryRequest}
 */
proto.manager.v1.ManagerLocationListQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegionid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerLocationListQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerLocationListQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerLocationListQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerLocationListQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRegionid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string lName = 1;
 * @return {string}
 */
proto.manager.v1.ManagerLocationListQueryRequest.prototype.getLname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerLocationListQueryRequest} returns this
 */
proto.manager.v1.ManagerLocationListQueryRequest.prototype.setLname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string regionId = 2;
 * @return {string}
 */
proto.manager.v1.ManagerLocationListQueryRequest.prototype.getRegionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerLocationListQueryRequest} returns this
 */
proto.manager.v1.ManagerLocationListQueryRequest.prototype.setRegionid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.manager.v1.ManagerLocationListQueryRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerLocationListQueryRequest} returns this
 */
proto.manager.v1.ManagerLocationListQueryRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 tableMax = 4;
 * @return {number}
 */
proto.manager.v1.ManagerLocationListQueryRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerLocationListQueryRequest} returns this
 */
proto.manager.v1.ManagerLocationListQueryRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerLocationInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerLocationInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerLocationInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerLocationInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
lid: jspb.Message.getFieldWithDefault(msg, 1, 0),
lname: jspb.Message.getFieldWithDefault(msg, 2, ""),
regionid: jspb.Message.getFieldWithDefault(msg, 3, ""),
addr: jspb.Message.getFieldWithDefault(msg, 4, ""),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
declination: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
status: jspb.Message.getFieldWithDefault(msg, 8, 0),
createdtime: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerLocationInfo}
 */
proto.manager.v1.ManagerLocationInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerLocationInfo;
  return proto.manager.v1.ManagerLocationInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerLocationInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerLocationInfo}
 */
proto.manager.v1.ManagerLocationInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegionid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddr(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDeclination(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerLocationInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerLocationInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerLocationInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerLocationInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRegionid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddr();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getDeclination();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCreatedtime();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional int32 lId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerLocationInfo.prototype.getLid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerLocationInfo} returns this
 */
proto.manager.v1.ManagerLocationInfo.prototype.setLid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string lName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerLocationInfo.prototype.getLname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerLocationInfo} returns this
 */
proto.manager.v1.ManagerLocationInfo.prototype.setLname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string regionId = 3;
 * @return {string}
 */
proto.manager.v1.ManagerLocationInfo.prototype.getRegionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerLocationInfo} returns this
 */
proto.manager.v1.ManagerLocationInfo.prototype.setRegionid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string addr = 4;
 * @return {string}
 */
proto.manager.v1.ManagerLocationInfo.prototype.getAddr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerLocationInfo} returns this
 */
proto.manager.v1.ManagerLocationInfo.prototype.setAddr = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double longitude = 5;
 * @return {number}
 */
proto.manager.v1.ManagerLocationInfo.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerLocationInfo} returns this
 */
proto.manager.v1.ManagerLocationInfo.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double latitude = 6;
 * @return {number}
 */
proto.manager.v1.ManagerLocationInfo.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerLocationInfo} returns this
 */
proto.manager.v1.ManagerLocationInfo.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double declination = 7;
 * @return {number}
 */
proto.manager.v1.ManagerLocationInfo.prototype.getDeclination = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerLocationInfo} returns this
 */
proto.manager.v1.ManagerLocationInfo.prototype.setDeclination = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional int32 status = 8;
 * @return {number}
 */
proto.manager.v1.ManagerLocationInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerLocationInfo} returns this
 */
proto.manager.v1.ManagerLocationInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string createdTime = 9;
 * @return {string}
 */
proto.manager.v1.ManagerLocationInfo.prototype.getCreatedtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerLocationInfo} returns this
 */
proto.manager.v1.ManagerLocationInfo.prototype.setCreatedtime = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerLocationAddRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerLocationAddRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerLocationAddRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerLocationAddRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
lname: jspb.Message.getFieldWithDefault(msg, 1, ""),
regionid: jspb.Message.getFieldWithDefault(msg, 2, ""),
addr: jspb.Message.getFieldWithDefault(msg, 3, ""),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerLocationAddRequest}
 */
proto.manager.v1.ManagerLocationAddRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerLocationAddRequest;
  return proto.manager.v1.ManagerLocationAddRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerLocationAddRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerLocationAddRequest}
 */
proto.manager.v1.ManagerLocationAddRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegionid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddr(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerLocationAddRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerLocationAddRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerLocationAddRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerLocationAddRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRegionid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddr();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional string lName = 1;
 * @return {string}
 */
proto.manager.v1.ManagerLocationAddRequest.prototype.getLname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerLocationAddRequest} returns this
 */
proto.manager.v1.ManagerLocationAddRequest.prototype.setLname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string regionId = 2;
 * @return {string}
 */
proto.manager.v1.ManagerLocationAddRequest.prototype.getRegionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerLocationAddRequest} returns this
 */
proto.manager.v1.ManagerLocationAddRequest.prototype.setRegionid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string addr = 3;
 * @return {string}
 */
proto.manager.v1.ManagerLocationAddRequest.prototype.getAddr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerLocationAddRequest} returns this
 */
proto.manager.v1.ManagerLocationAddRequest.prototype.setAddr = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double longitude = 4;
 * @return {number}
 */
proto.manager.v1.ManagerLocationAddRequest.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerLocationAddRequest} returns this
 */
proto.manager.v1.ManagerLocationAddRequest.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double latitude = 5;
 * @return {number}
 */
proto.manager.v1.ManagerLocationAddRequest.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerLocationAddRequest} returns this
 */
proto.manager.v1.ManagerLocationAddRequest.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerLocationEditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerLocationEditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerLocationEditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
lid: jspb.Message.getFieldWithDefault(msg, 1, 0),
lname: jspb.Message.getFieldWithDefault(msg, 2, ""),
regionid: jspb.Message.getFieldWithDefault(msg, 3, ""),
addr: jspb.Message.getFieldWithDefault(msg, 4, ""),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerLocationEditRequest}
 */
proto.manager.v1.ManagerLocationEditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerLocationEditRequest;
  return proto.manager.v1.ManagerLocationEditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerLocationEditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerLocationEditRequest}
 */
proto.manager.v1.ManagerLocationEditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegionid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddr(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerLocationEditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerLocationEditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerLocationEditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRegionid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddr();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional int32 lId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.getLid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerLocationEditRequest} returns this
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.setLid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string lName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.getLname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerLocationEditRequest} returns this
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.setLname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string regionId = 3;
 * @return {string}
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.getRegionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerLocationEditRequest} returns this
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.setRegionid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string addr = 4;
 * @return {string}
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.getAddr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerLocationEditRequest} returns this
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.setAddr = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double longitude = 5;
 * @return {number}
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerLocationEditRequest} returns this
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double latitude = 6;
 * @return {number}
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerLocationEditRequest} returns this
 */
proto.manager.v1.ManagerLocationEditRequest.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerMapListQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerMapListQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerMapListQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerMapListQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
lid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapname: jspb.Message.getFieldWithDefault(msg, 2, ""),
pincode: jspb.Message.getFieldWithDefault(msg, 3, ""),
page: jspb.Message.getFieldWithDefault(msg, 4, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerMapListQueryRequest}
 */
proto.manager.v1.ManagerMapListQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerMapListQueryRequest;
  return proto.manager.v1.ManagerMapListQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerMapListQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerMapListQueryRequest}
 */
proto.manager.v1.ManagerMapListQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPincode(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerMapListQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerMapListQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerMapListQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerMapListQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPincode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 lId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerMapListQueryRequest.prototype.getLid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapListQueryRequest} returns this
 */
proto.manager.v1.ManagerMapListQueryRequest.prototype.setLid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string mapName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerMapListQueryRequest.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapListQueryRequest} returns this
 */
proto.manager.v1.ManagerMapListQueryRequest.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string pinCode = 3;
 * @return {string}
 */
proto.manager.v1.ManagerMapListQueryRequest.prototype.getPincode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapListQueryRequest} returns this
 */
proto.manager.v1.ManagerMapListQueryRequest.prototype.setPincode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page = 4;
 * @return {number}
 */
proto.manager.v1.ManagerMapListQueryRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapListQueryRequest} returns this
 */
proto.manager.v1.ManagerMapListQueryRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 tableMax = 5;
 * @return {number}
 */
proto.manager.v1.ManagerMapListQueryRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapListQueryRequest} returns this
 */
proto.manager.v1.ManagerMapListQueryRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerMapInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerMapInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerMapInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerMapInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
lname: jspb.Message.getFieldWithDefault(msg, 2, ""),
mapname: jspb.Message.getFieldWithDefault(msg, 3, ""),
mapscalenumber: jspb.Message.getFieldWithDefault(msg, 4, 0),
contourinterval: jspb.Message.getFieldWithDefault(msg, 5, 0),
prepicurl: jspb.Message.getFieldWithDefault(msg, 6, ""),
zipurl: jspb.Message.getFieldWithDefault(msg, 7, ""),
ordernum: jspb.Message.getFieldWithDefault(msg, 9, 0),
level: jspb.Message.getFieldWithDefault(msg, 10, 0),
isrecommend: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
isopen: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
mapdescription: jspb.Message.getFieldWithDefault(msg, 13, ""),
isappshow: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
ispinjoin: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
pincode: jspb.Message.getFieldWithDefault(msg, 16, ""),
lid: jspb.Message.getFieldWithDefault(msg, 17, 0),
roadway: jspb.Message.getFieldWithDefault(msg, 18, ""),
lawn: jspb.Message.getFieldWithDefault(msg, 19, ""),
waters: jspb.Message.getFieldWithDefault(msg, 20, ""),
restrictedarea: jspb.Message.getFieldWithDefault(msg, 21, ""),
status: jspb.Message.getFieldWithDefault(msg, 22, 0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 24, 0.0),
createdtime: jspb.Message.getFieldWithDefault(msg, 25, ""),
previewurl: jspb.Message.getFieldWithDefault(msg, 26, ""),
tomapurl: jspb.Message.getFieldWithDefault(msg, 27, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerMapInfo}
 */
proto.manager.v1.ManagerMapInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerMapInfo;
  return proto.manager.v1.ManagerMapInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerMapInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerMapInfo}
 */
proto.manager.v1.ManagerMapInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapscalenumber(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContourinterval(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrepicurl(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipurl(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdernum(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLevel(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsrecommend(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsopen(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapdescription(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsappshow(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIspinjoin(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setPincode(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLid(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoadway(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setLawn(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setWaters(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setRestrictedarea(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedtime(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviewurl(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setTomapurl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerMapInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerMapInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerMapInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerMapInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMapscalenumber();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getContourinterval();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPrepicurl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getZipurl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getOrdernum();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getIsrecommend();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getIsopen();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getMapdescription();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getIsappshow();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getIspinjoin();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getPincode();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getLid();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getRoadway();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getLawn();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getWaters();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getRestrictedarea();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      22,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      24,
      f
    );
  }
  f = message.getCreatedtime();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getPreviewurl();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getTomapurl();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerMapInfo.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string lName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getLname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setLname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string mapName = 3;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 mapScaleNumber = 4;
 * @return {number}
 */
proto.manager.v1.ManagerMapInfo.prototype.getMapscalenumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setMapscalenumber = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 contourInterval = 5;
 * @return {number}
 */
proto.manager.v1.ManagerMapInfo.prototype.getContourinterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setContourinterval = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string prePicUrl = 6;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getPrepicurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setPrepicurl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string zipUrl = 7;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getZipurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setZipurl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 orderNum = 9;
 * @return {number}
 */
proto.manager.v1.ManagerMapInfo.prototype.getOrdernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setOrdernum = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 level = 10;
 * @return {number}
 */
proto.manager.v1.ManagerMapInfo.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional bool isRecommend = 11;
 * @return {boolean}
 */
proto.manager.v1.ManagerMapInfo.prototype.getIsrecommend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setIsrecommend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool isOpen = 12;
 * @return {boolean}
 */
proto.manager.v1.ManagerMapInfo.prototype.getIsopen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setIsopen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string mapDescription = 13;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getMapdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setMapdescription = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool isAppShow = 14;
 * @return {boolean}
 */
proto.manager.v1.ManagerMapInfo.prototype.getIsappshow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setIsappshow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool isPinJoin = 15;
 * @return {boolean}
 */
proto.manager.v1.ManagerMapInfo.prototype.getIspinjoin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setIspinjoin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string pinCode = 16;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getPincode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setPincode = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int32 lId = 17;
 * @return {number}
 */
proto.manager.v1.ManagerMapInfo.prototype.getLid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setLid = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string roadway = 18;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getRoadway = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setRoadway = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string lawn = 19;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getLawn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setLawn = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string waters = 20;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getWaters = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setWaters = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string restrictedArea = 21;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getRestrictedarea = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setRestrictedarea = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional int32 status = 22;
 * @return {number}
 */
proto.manager.v1.ManagerMapInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional double longitude = 23;
 * @return {number}
 */
proto.manager.v1.ManagerMapInfo.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional double latitude = 24;
 * @return {number}
 */
proto.manager.v1.ManagerMapInfo.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 24, value);
};


/**
 * optional string createdTime = 25;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getCreatedtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setCreatedtime = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string previewUrl = 26;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getPreviewurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setPreviewurl = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string toMapUrl = 27;
 * @return {string}
 */
proto.manager.v1.ManagerMapInfo.prototype.getTomapurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapInfo} returns this
 */
proto.manager.v1.ManagerMapInfo.prototype.setTomapurl = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerMapAddRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerMapAddRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerMapAddRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
mapname: jspb.Message.getFieldWithDefault(msg, 1, ""),
lid: jspb.Message.getFieldWithDefault(msg, 2, 0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
mapscalenumber: jspb.Message.getFieldWithDefault(msg, 5, 0),
contourinterval: jspb.Message.getFieldWithDefault(msg, 6, 0),
ordernum: jspb.Message.getFieldWithDefault(msg, 7, 0),
level: jspb.Message.getFieldWithDefault(msg, 8, 0),
isrecommend: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
isopen: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
mapdescription: jspb.Message.getFieldWithDefault(msg, 11, ""),
isappshow: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
ispinjoin: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
pincode: jspb.Message.getFieldWithDefault(msg, 14, ""),
roadway: jspb.Message.getFieldWithDefault(msg, 15, ""),
lawn: jspb.Message.getFieldWithDefault(msg, 16, ""),
waters: jspb.Message.getFieldWithDefault(msg, 17, ""),
restrictedarea: jspb.Message.getFieldWithDefault(msg, 18, ""),
mapzipdata: (f = msg.getMapzipdata()) && base_pb.Image.toObject(includeInstance, f),
prepicdata: (f = msg.getPrepicdata()) && base_pb.Image.toObject(includeInstance, f),
prezipdata: (f = msg.getPrezipdata()) && base_pb.Image.toObject(includeInstance, f),
tozipdata: (f = msg.getTozipdata()) && base_pb.Image.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerMapAddRequest}
 */
proto.manager.v1.ManagerMapAddRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerMapAddRequest;
  return proto.manager.v1.ManagerMapAddRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerMapAddRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerMapAddRequest}
 */
proto.manager.v1.ManagerMapAddRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapscalenumber(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContourinterval(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdernum(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLevel(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsrecommend(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsopen(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapdescription(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsappshow(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIspinjoin(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setPincode(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoadway(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLawn(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setWaters(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setRestrictedarea(value);
      break;
    case 19:
      var value = new base_pb.Image;
      reader.readMessage(value,base_pb.Image.deserializeBinaryFromReader);
      msg.setMapzipdata(value);
      break;
    case 20:
      var value = new base_pb.Image;
      reader.readMessage(value,base_pb.Image.deserializeBinaryFromReader);
      msg.setPrepicdata(value);
      break;
    case 21:
      var value = new base_pb.Image;
      reader.readMessage(value,base_pb.Image.deserializeBinaryFromReader);
      msg.setPrezipdata(value);
      break;
    case 22:
      var value = new base_pb.Image;
      reader.readMessage(value,base_pb.Image.deserializeBinaryFromReader);
      msg.setTozipdata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerMapAddRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerMapAddRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerMapAddRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMapscalenumber();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getContourinterval();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getOrdernum();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getIsrecommend();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getIsopen();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getMapdescription();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getIsappshow();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getIspinjoin();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getPincode();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getRoadway();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getLawn();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getWaters();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getRestrictedarea();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getMapzipdata();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      base_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getPrepicdata();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      base_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getPrezipdata();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      base_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getTozipdata();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      base_pb.Image.serializeBinaryToWriter
    );
  }
};


/**
 * optional string mapName = 1;
 * @return {string}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 lId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getLid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setLid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double longitude = 3;
 * @return {number}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double latitude = 4;
 * @return {number}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int32 mapScaleNumber = 5;
 * @return {number}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getMapscalenumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setMapscalenumber = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 contourInterval = 6;
 * @return {number}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getContourinterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setContourinterval = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 orderNum = 7;
 * @return {number}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getOrdernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setOrdernum = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 level = 8;
 * @return {number}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool isRecommend = 9;
 * @return {boolean}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getIsrecommend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setIsrecommend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool isOpen = 10;
 * @return {boolean}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getIsopen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setIsopen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string mapDescription = 11;
 * @return {string}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getMapdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setMapdescription = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool isAppShow = 12;
 * @return {boolean}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getIsappshow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setIsappshow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool isPinJoin = 13;
 * @return {boolean}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getIspinjoin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setIspinjoin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string pinCode = 14;
 * @return {string}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getPincode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setPincode = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string roadway = 15;
 * @return {string}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getRoadway = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setRoadway = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string lawn = 16;
 * @return {string}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getLawn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setLawn = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string waters = 17;
 * @return {string}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getWaters = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setWaters = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string restrictedArea = 18;
 * @return {string}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getRestrictedarea = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.setRestrictedarea = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional base.v1.Image mapZipData = 19;
 * @return {?proto.base.v1.Image}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getMapzipdata = function() {
  return /** @type{?proto.base.v1.Image} */ (
    jspb.Message.getWrapperField(this, base_pb.Image, 19));
};


/**
 * @param {?proto.base.v1.Image|undefined} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
*/
proto.manager.v1.ManagerMapAddRequest.prototype.setMapzipdata = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.clearMapzipdata = function() {
  return this.setMapzipdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.hasMapzipdata = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional base.v1.Image prePicData = 20;
 * @return {?proto.base.v1.Image}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getPrepicdata = function() {
  return /** @type{?proto.base.v1.Image} */ (
    jspb.Message.getWrapperField(this, base_pb.Image, 20));
};


/**
 * @param {?proto.base.v1.Image|undefined} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
*/
proto.manager.v1.ManagerMapAddRequest.prototype.setPrepicdata = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.clearPrepicdata = function() {
  return this.setPrepicdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.hasPrepicdata = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional base.v1.Image preZipData = 21;
 * @return {?proto.base.v1.Image}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getPrezipdata = function() {
  return /** @type{?proto.base.v1.Image} */ (
    jspb.Message.getWrapperField(this, base_pb.Image, 21));
};


/**
 * @param {?proto.base.v1.Image|undefined} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
*/
proto.manager.v1.ManagerMapAddRequest.prototype.setPrezipdata = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.clearPrezipdata = function() {
  return this.setPrezipdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.hasPrezipdata = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional base.v1.Image toZipData = 22;
 * @return {?proto.base.v1.Image}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.getTozipdata = function() {
  return /** @type{?proto.base.v1.Image} */ (
    jspb.Message.getWrapperField(this, base_pb.Image, 22));
};


/**
 * @param {?proto.base.v1.Image|undefined} value
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
*/
proto.manager.v1.ManagerMapAddRequest.prototype.setTozipdata = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ManagerMapAddRequest} returns this
 */
proto.manager.v1.ManagerMapAddRequest.prototype.clearTozipdata = function() {
  return this.setTozipdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ManagerMapAddRequest.prototype.hasTozipdata = function() {
  return jspb.Message.getField(this, 22) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerMapEditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerMapEditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerMapEditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapname: jspb.Message.getFieldWithDefault(msg, 2, ""),
lid: jspb.Message.getFieldWithDefault(msg, 3, 0),
ordernum: jspb.Message.getFieldWithDefault(msg, 4, 0),
level: jspb.Message.getFieldWithDefault(msg, 5, 0),
isrecommend: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
isopen: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
mapdescription: jspb.Message.getFieldWithDefault(msg, 8, ""),
isappshow: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
ispinjoin: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
pincode: jspb.Message.getFieldWithDefault(msg, 11, ""),
roadway: jspb.Message.getFieldWithDefault(msg, 12, ""),
lawn: jspb.Message.getFieldWithDefault(msg, 13, ""),
waters: jspb.Message.getFieldWithDefault(msg, 14, ""),
restrictedarea: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerMapEditRequest}
 */
proto.manager.v1.ManagerMapEditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerMapEditRequest;
  return proto.manager.v1.ManagerMapEditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerMapEditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerMapEditRequest}
 */
proto.manager.v1.ManagerMapEditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdernum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLevel(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsrecommend(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsopen(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapdescription(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsappshow(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIspinjoin(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPincode(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoadway(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setLawn(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setWaters(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setRestrictedarea(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerMapEditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerMapEditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerMapEditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getOrdernum();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getIsrecommend();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsopen();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getMapdescription();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsappshow();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getIspinjoin();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getPincode();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getRoadway();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLawn();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getWaters();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getRestrictedarea();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string mapName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 lId = 3;
 * @return {number}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getLid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setLid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 orderNum = 4;
 * @return {number}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getOrdernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setOrdernum = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 level = 5;
 * @return {number}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool isRecommend = 6;
 * @return {boolean}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getIsrecommend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setIsrecommend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool isOpen = 7;
 * @return {boolean}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getIsopen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setIsopen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string mapDescription = 8;
 * @return {string}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getMapdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setMapdescription = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool isAppShow = 9;
 * @return {boolean}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getIsappshow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setIsappshow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool isPinJoin = 10;
 * @return {boolean}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getIspinjoin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setIspinjoin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string pinCode = 11;
 * @return {string}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getPincode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setPincode = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string roadway = 12;
 * @return {string}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getRoadway = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setRoadway = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string lawn = 13;
 * @return {string}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getLawn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setLawn = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string waters = 14;
 * @return {string}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getWaters = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setWaters = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string restrictedArea = 15;
 * @return {string}
 */
proto.manager.v1.ManagerMapEditRequest.prototype.getRestrictedarea = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerMapEditRequest} returns this
 */
proto.manager.v1.ManagerMapEditRequest.prototype.setRestrictedarea = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerMapHistoryEditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerMapHistoryEditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerMapHistoryEditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
mapscalenumber: jspb.Message.getFieldWithDefault(msg, 5, 0),
contourinterval: jspb.Message.getFieldWithDefault(msg, 6, 0),
mapzipdata: (f = msg.getMapzipdata()) && base_pb.Image.toObject(includeInstance, f),
prepicdata: (f = msg.getPrepicdata()) && base_pb.Image.toObject(includeInstance, f),
prezipdata: (f = msg.getPrezipdata()) && base_pb.Image.toObject(includeInstance, f),
tozipdata: (f = msg.getTozipdata()) && base_pb.Image.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerMapHistoryEditRequest;
  return proto.manager.v1.ManagerMapHistoryEditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerMapHistoryEditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapscalenumber(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContourinterval(value);
      break;
    case 7:
      var value = new base_pb.Image;
      reader.readMessage(value,base_pb.Image.deserializeBinaryFromReader);
      msg.setMapzipdata(value);
      break;
    case 8:
      var value = new base_pb.Image;
      reader.readMessage(value,base_pb.Image.deserializeBinaryFromReader);
      msg.setPrepicdata(value);
      break;
    case 9:
      var value = new base_pb.Image;
      reader.readMessage(value,base_pb.Image.deserializeBinaryFromReader);
      msg.setPrezipdata(value);
      break;
    case 10:
      var value = new base_pb.Image;
      reader.readMessage(value,base_pb.Image.deserializeBinaryFromReader);
      msg.setTozipdata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerMapHistoryEditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerMapHistoryEditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerMapHistoryEditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMapscalenumber();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getContourinterval();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMapzipdata();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      base_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getPrepicdata();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      base_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getPrezipdata();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      base_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getTozipdata();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      base_pb.Image.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double longitude = 2;
 * @return {number}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double latitude = 4;
 * @return {number}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int32 mapScaleNumber = 5;
 * @return {number}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.getMapscalenumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.setMapscalenumber = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 contourInterval = 6;
 * @return {number}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.getContourinterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.setContourinterval = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional base.v1.Image mapZipData = 7;
 * @return {?proto.base.v1.Image}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.getMapzipdata = function() {
  return /** @type{?proto.base.v1.Image} */ (
    jspb.Message.getWrapperField(this, base_pb.Image, 7));
};


/**
 * @param {?proto.base.v1.Image|undefined} value
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
*/
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.setMapzipdata = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.clearMapzipdata = function() {
  return this.setMapzipdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.hasMapzipdata = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional base.v1.Image prePicData = 8;
 * @return {?proto.base.v1.Image}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.getPrepicdata = function() {
  return /** @type{?proto.base.v1.Image} */ (
    jspb.Message.getWrapperField(this, base_pb.Image, 8));
};


/**
 * @param {?proto.base.v1.Image|undefined} value
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
*/
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.setPrepicdata = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.clearPrepicdata = function() {
  return this.setPrepicdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.hasPrepicdata = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional base.v1.Image preZipData = 9;
 * @return {?proto.base.v1.Image}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.getPrezipdata = function() {
  return /** @type{?proto.base.v1.Image} */ (
    jspb.Message.getWrapperField(this, base_pb.Image, 9));
};


/**
 * @param {?proto.base.v1.Image|undefined} value
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
*/
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.setPrezipdata = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.clearPrezipdata = function() {
  return this.setPrezipdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.hasPrezipdata = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional base.v1.Image toZipData = 10;
 * @return {?proto.base.v1.Image}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.getTozipdata = function() {
  return /** @type{?proto.base.v1.Image} */ (
    jspb.Message.getWrapperField(this, base_pb.Image, 10));
};


/**
 * @param {?proto.base.v1.Image|undefined} value
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
*/
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.setTozipdata = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ManagerMapHistoryEditRequest} returns this
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.clearTozipdata = function() {
  return this.setTozipdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ManagerMapHistoryEditRequest.prototype.hasTozipdata = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerControlPointImportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerControlPointImportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerControlPointImportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerControlPointImportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
kmldata: msg.getKmldata_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerControlPointImportRequest}
 */
proto.manager.v1.ManagerControlPointImportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerControlPointImportRequest;
  return proto.manager.v1.ManagerControlPointImportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerControlPointImportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerControlPointImportRequest}
 */
proto.manager.v1.ManagerControlPointImportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setKmldata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerControlPointImportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerControlPointImportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerControlPointImportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerControlPointImportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getKmldata_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointImportRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointImportRequest} returns this
 */
proto.manager.v1.ManagerControlPointImportRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bytes kmlData = 2;
 * @return {string}
 */
proto.manager.v1.ManagerControlPointImportRequest.prototype.getKmldata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes kmlData = 2;
 * This is a type-conversion wrapper around `getKmldata()`
 * @return {string}
 */
proto.manager.v1.ManagerControlPointImportRequest.prototype.getKmldata_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getKmldata()));
};


/**
 * optional bytes kmlData = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getKmldata()`
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerControlPointImportRequest.prototype.getKmldata_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getKmldata()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.manager.v1.ManagerControlPointImportRequest} returns this
 */
proto.manager.v1.ManagerControlPointImportRequest.prototype.setKmldata = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerControlPointListQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerControlPointListQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerControlPointListQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
isbegin: jspb.Message.getFieldWithDefault(msg, 2, 0),
cicode: jspb.Message.getFieldWithDefault(msg, 3, ""),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
page: jspb.Message.getFieldWithDefault(msg, 6, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerControlPointListQueryRequest}
 */
proto.manager.v1.ManagerControlPointListQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerControlPointListQueryRequest;
  return proto.manager.v1.ManagerControlPointListQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerControlPointListQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerControlPointListQueryRequest}
 */
proto.manager.v1.ManagerControlPointListQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsbegin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCicode(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerControlPointListQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerControlPointListQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerControlPointListQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIsbegin();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCicode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointListQueryRequest} returns this
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 isBegin = 2;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.getIsbegin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointListQueryRequest} returns this
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.setIsbegin = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string ciCode = 3;
 * @return {string}
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.getCicode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerControlPointListQueryRequest} returns this
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.setCicode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double longitude = 4;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointListQueryRequest} returns this
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double latitude = 5;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointListQueryRequest} returns this
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int32 page = 6;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointListQueryRequest} returns this
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 tableMax = 7;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointListQueryRequest} returns this
 */
proto.manager.v1.ManagerControlPointListQueryRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.manager.v1.ManagerControlPointListQueryReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerControlPointListQueryReply.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerControlPointListQueryReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerControlPointListQueryReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerControlPointListQueryReply.toObject = function(includeInstance, msg) {
  var f, obj = {
rsList: jspb.Message.toObjectList(msg.getRsList(),
    proto.manager.v1.ManagerControlPointInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerControlPointListQueryReply}
 */
proto.manager.v1.ManagerControlPointListQueryReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerControlPointListQueryReply;
  return proto.manager.v1.ManagerControlPointListQueryReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerControlPointListQueryReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerControlPointListQueryReply}
 */
proto.manager.v1.ManagerControlPointListQueryReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.manager.v1.ManagerControlPointInfo;
      reader.readMessage(value,proto.manager.v1.ManagerControlPointInfo.deserializeBinaryFromReader);
      msg.addRs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerControlPointListQueryReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerControlPointListQueryReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerControlPointListQueryReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerControlPointListQueryReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.manager.v1.ManagerControlPointInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ManagerControlPointInfo Rs = 1;
 * @return {!Array<!proto.manager.v1.ManagerControlPointInfo>}
 */
proto.manager.v1.ManagerControlPointListQueryReply.prototype.getRsList = function() {
  return /** @type{!Array<!proto.manager.v1.ManagerControlPointInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.manager.v1.ManagerControlPointInfo, 1));
};


/**
 * @param {!Array<!proto.manager.v1.ManagerControlPointInfo>} value
 * @return {!proto.manager.v1.ManagerControlPointListQueryReply} returns this
*/
proto.manager.v1.ManagerControlPointListQueryReply.prototype.setRsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.manager.v1.ManagerControlPointInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manager.v1.ManagerControlPointInfo}
 */
proto.manager.v1.ManagerControlPointListQueryReply.prototype.addRs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manager.v1.ManagerControlPointInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.manager.v1.ManagerControlPointListQueryReply} returns this
 */
proto.manager.v1.ManagerControlPointListQueryReply.prototype.clearRsList = function() {
  return this.setRsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerControlPointInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerControlPointInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerControlPointInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerControlPointInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
cpid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapname: jspb.Message.getFieldWithDefault(msg, 2, ""),
cicode: jspb.Message.getFieldWithDefault(msg, 3, ""),
cdescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
isbegin: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
status: jspb.Message.getFieldWithDefault(msg, 6, 0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerControlPointInfo}
 */
proto.manager.v1.ManagerControlPointInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerControlPointInfo;
  return proto.manager.v1.ManagerControlPointInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerControlPointInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerControlPointInfo}
 */
proto.manager.v1.ManagerControlPointInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCpid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCicode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCdescription(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsbegin(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerControlPointInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerControlPointInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerControlPointInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerControlPointInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCpid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCicode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCdescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIsbegin();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
};


/**
 * optional int32 cpId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointInfo.prototype.getCpid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointInfo} returns this
 */
proto.manager.v1.ManagerControlPointInfo.prototype.setCpid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string mapName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerControlPointInfo.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerControlPointInfo} returns this
 */
proto.manager.v1.ManagerControlPointInfo.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ciCode = 3;
 * @return {string}
 */
proto.manager.v1.ManagerControlPointInfo.prototype.getCicode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerControlPointInfo} returns this
 */
proto.manager.v1.ManagerControlPointInfo.prototype.setCicode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string cDescription = 4;
 * @return {string}
 */
proto.manager.v1.ManagerControlPointInfo.prototype.getCdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerControlPointInfo} returns this
 */
proto.manager.v1.ManagerControlPointInfo.prototype.setCdescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool isBegin = 5;
 * @return {boolean}
 */
proto.manager.v1.ManagerControlPointInfo.prototype.getIsbegin = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerControlPointInfo} returns this
 */
proto.manager.v1.ManagerControlPointInfo.prototype.setIsbegin = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int32 status = 6;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointInfo} returns this
 */
proto.manager.v1.ManagerControlPointInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double longitude = 7;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointInfo.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointInfo} returns this
 */
proto.manager.v1.ManagerControlPointInfo.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double latitude = 8;
 * @return {number}
 */
proto.manager.v1.ManagerControlPointInfo.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerControlPointInfo} returns this
 */
proto.manager.v1.ManagerControlPointInfo.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerRouteListQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerRouteListQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerRouteListQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRouteListQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
lid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapid: jspb.Message.getFieldWithDefault(msg, 2, 0),
cname: jspb.Message.getFieldWithDefault(msg, 3, ""),
page: jspb.Message.getFieldWithDefault(msg, 4, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerRouteListQueryRequest}
 */
proto.manager.v1.ManagerRouteListQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerRouteListQueryRequest;
  return proto.manager.v1.ManagerRouteListQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerRouteListQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerRouteListQueryRequest}
 */
proto.manager.v1.ManagerRouteListQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCname(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerRouteListQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerRouteListQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerRouteListQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRouteListQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 lId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerRouteListQueryRequest.prototype.getLid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteListQueryRequest} returns this
 */
proto.manager.v1.ManagerRouteListQueryRequest.prototype.setLid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 mapId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerRouteListQueryRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteListQueryRequest} returns this
 */
proto.manager.v1.ManagerRouteListQueryRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string cName = 3;
 * @return {string}
 */
proto.manager.v1.ManagerRouteListQueryRequest.prototype.getCname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerRouteListQueryRequest} returns this
 */
proto.manager.v1.ManagerRouteListQueryRequest.prototype.setCname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page = 4;
 * @return {number}
 */
proto.manager.v1.ManagerRouteListQueryRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteListQueryRequest} returns this
 */
proto.manager.v1.ManagerRouteListQueryRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 tableMax = 5;
 * @return {number}
 */
proto.manager.v1.ManagerRouteListQueryRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteListQueryRequest} returns this
 */
proto.manager.v1.ManagerRouteListQueryRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerRouteListQueryInPackageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerRouteListQueryInPackageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
packageid: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerRouteListQueryInPackageRequest}
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerRouteListQueryInPackageRequest;
  return proto.manager.v1.ManagerRouteListQueryInPackageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerRouteListQueryInPackageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerRouteListQueryInPackageRequest}
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPackageid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerRouteListQueryInPackageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerRouteListQueryInPackageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackageid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 packageId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest.prototype.getPackageid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteListQueryInPackageRequest} returns this
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteListQueryInPackageRequest} returns this
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 tableMax = 5;
 * @return {number}
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteListQueryInPackageRequest} returns this
 */
proto.manager.v1.ManagerRouteListQueryInPackageRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerRouteListQueryOutPackageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerRouteListQueryOutPackageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
packageid: jspb.Message.getFieldWithDefault(msg, 1, 0),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerRouteListQueryOutPackageRequest}
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerRouteListQueryOutPackageRequest;
  return proto.manager.v1.ManagerRouteListQueryOutPackageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerRouteListQueryOutPackageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerRouteListQueryOutPackageRequest}
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPackageid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerRouteListQueryOutPackageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerRouteListQueryOutPackageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackageid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 packageId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest.prototype.getPackageid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteListQueryOutPackageRequest} returns this
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteListQueryOutPackageRequest} returns this
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 tableMax = 3;
 * @return {number}
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteListQueryOutPackageRequest} returns this
 */
proto.manager.v1.ManagerRouteListQueryOutPackageRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerRouteInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerRouteInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerRouteInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRouteInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
cid: jspb.Message.getFieldWithDefault(msg, 1, 0),
cname: jspb.Message.getFieldWithDefault(msg, 2, ""),
lid: jspb.Message.getFieldWithDefault(msg, 3, 0),
mapid: jspb.Message.getFieldWithDefault(msg, 4, 0),
controlnum: jspb.Message.getFieldWithDefault(msg, 5, 0),
maxrange: jspb.Message.getFieldWithDefault(msg, 6, 0),
prepicurl: jspb.Message.getFieldWithDefault(msg, 7, ""),
isnfc: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
altitudediffmeter: jspb.Message.getFieldWithDefault(msg, 9, 0),
minpointrange: jspb.Message.getFieldWithDefault(msg, 10, 0),
legendpicurl: jspb.Message.getFieldWithDefault(msg, 11, ""),
lname: jspb.Message.getFieldWithDefault(msg, 12, ""),
mapname: jspb.Message.getFieldWithDefault(msg, 13, ""),
status: jspb.Message.getFieldWithDefault(msg, 14, 0),
memo: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerRouteInfo}
 */
proto.manager.v1.ManagerRouteInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerRouteInfo;
  return proto.manager.v1.ManagerRouteInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerRouteInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerRouteInfo}
 */
proto.manager.v1.ManagerRouteInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setControlnum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxrange(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrepicurl(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsnfc(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAltitudediffmeter(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinpointrange(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegendpicurl(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLname(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerRouteInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerRouteInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerRouteInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRouteInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getControlnum();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMaxrange();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPrepicurl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsnfc();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getAltitudediffmeter();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getMinpointrange();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getLegendpicurl();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLname();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getMemo();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional int32 cId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getCid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setCid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string cName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getCname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setCname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 lId = 3;
 * @return {number}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getLid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setLid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 mapId = 4;
 * @return {number}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 controlNum = 5;
 * @return {number}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getControlnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setControlnum = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 maxRange = 6;
 * @return {number}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getMaxrange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setMaxrange = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string prePicUrl = 7;
 * @return {string}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getPrepicurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setPrepicurl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool isNfc = 8;
 * @return {boolean}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getIsnfc = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setIsnfc = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int32 altitudeDiffMeter = 9;
 * @return {number}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getAltitudediffmeter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setAltitudediffmeter = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 minPointRange = 10;
 * @return {number}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getMinpointrange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setMinpointrange = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string legendPicUrl = 11;
 * @return {string}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getLegendpicurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setLegendpicurl = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string lName = 12;
 * @return {string}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getLname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setLname = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string mapName = 13;
 * @return {string}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 status = 14;
 * @return {number}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string memo = 15;
 * @return {string}
 */
proto.manager.v1.ManagerRouteInfo.prototype.getMemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerRouteInfo} returns this
 */
proto.manager.v1.ManagerRouteInfo.prototype.setMemo = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerRouteAddRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerRouteAddRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRouteAddRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
cname: jspb.Message.getFieldWithDefault(msg, 2, ""),
kmldata: msg.getKmldata_asB64(),
category: jspb.Message.getFieldWithDefault(msg, 4, 0),
memo: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerRouteAddRequest}
 */
proto.manager.v1.ManagerRouteAddRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerRouteAddRequest;
  return proto.manager.v1.ManagerRouteAddRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerRouteAddRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerRouteAddRequest}
 */
proto.manager.v1.ManagerRouteAddRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCname(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setKmldata(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCategory(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerRouteAddRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerRouteAddRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRouteAddRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKmldata_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMemo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteAddRequest} returns this
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string cName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.getCname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerRouteAddRequest} returns this
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.setCname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes kmlData = 3;
 * @return {string}
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.getKmldata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes kmlData = 3;
 * This is a type-conversion wrapper around `getKmldata()`
 * @return {string}
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.getKmldata_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getKmldata()));
};


/**
 * optional bytes kmlData = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getKmldata()`
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.getKmldata_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getKmldata()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.manager.v1.ManagerRouteAddRequest} returns this
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.setKmldata = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional int32 category = 4;
 * @return {number}
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.getCategory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteAddRequest} returns this
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string memo = 5;
 * @return {string}
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.getMemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerRouteAddRequest} returns this
 */
proto.manager.v1.ManagerRouteAddRequest.prototype.setMemo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerRouteEditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerRouteEditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerRouteEditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRouteEditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
cid: jspb.Message.getFieldWithDefault(msg, 1, 0),
cname: jspb.Message.getFieldWithDefault(msg, 2, ""),
memo: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerRouteEditRequest}
 */
proto.manager.v1.ManagerRouteEditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerRouteEditRequest;
  return proto.manager.v1.ManagerRouteEditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerRouteEditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerRouteEditRequest}
 */
proto.manager.v1.ManagerRouteEditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerRouteEditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerRouteEditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerRouteEditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerRouteEditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMemo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 cId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerRouteEditRequest.prototype.getCid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerRouteEditRequest} returns this
 */
proto.manager.v1.ManagerRouteEditRequest.prototype.setCid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string cName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerRouteEditRequest.prototype.getCname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerRouteEditRequest} returns this
 */
proto.manager.v1.ManagerRouteEditRequest.prototype.setCname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string memo = 3;
 * @return {string}
 */
proto.manager.v1.ManagerRouteEditRequest.prototype.getMemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerRouteEditRequest} returns this
 */
proto.manager.v1.ManagerRouteEditRequest.prototype.setMemo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerCoursePackageListQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerCoursePackageListQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
lid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapid: jspb.Message.getFieldWithDefault(msg, 2, 0),
cpname: jspb.Message.getFieldWithDefault(msg, 3, ""),
begincicode: jspb.Message.getFieldWithDefault(msg, 4, ""),
page: jspb.Message.getFieldWithDefault(msg, 5, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerCoursePackageListQueryRequest}
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerCoursePackageListQueryRequest;
  return proto.manager.v1.ManagerCoursePackageListQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerCoursePackageListQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerCoursePackageListQueryRequest}
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCpname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBegincicode(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerCoursePackageListQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerCoursePackageListQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCpname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBegincicode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional int32 lId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.getLid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageListQueryRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.setLid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 mapId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageListQueryRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string cpName = 3;
 * @return {string}
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.getCpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerCoursePackageListQueryRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.setCpname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string beginCiCode = 4;
 * @return {string}
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.getBegincicode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerCoursePackageListQueryRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.setBegincicode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 page = 5;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageListQueryRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 tableMax = 6;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageListQueryRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageListQueryRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerCoursePackageInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerCoursePackageInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerCoursePackageInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
packageid: jspb.Message.getFieldWithDefault(msg, 1, 0),
lid: jspb.Message.getFieldWithDefault(msg, 2, 0),
mapid: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 4, 0),
cpcategory: jspb.Message.getFieldWithDefault(msg, 5, 0),
begincpid: jspb.Message.getFieldWithDefault(msg, 6, 0),
cpname: jspb.Message.getFieldWithDefault(msg, 7, ""),
cpdescription: jspb.Message.getFieldWithDefault(msg, 8, ""),
lname: jspb.Message.getFieldWithDefault(msg, 12, ""),
mapname: jspb.Message.getFieldWithDefault(msg, 13, ""),
status: jspb.Message.getFieldWithDefault(msg, 14, 0),
routenum: jspb.Message.getFieldWithDefault(msg, 15, 0),
createdtime: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerCoursePackageInfo}
 */
proto.manager.v1.ManagerCoursePackageInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerCoursePackageInfo;
  return proto.manager.v1.ManagerCoursePackageInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerCoursePackageInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerCoursePackageInfo}
 */
proto.manager.v1.ManagerCoursePackageInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPackageid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCpcategory(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBegincpid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCpname(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCpdescription(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLname(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoutenum(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerCoursePackageInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerCoursePackageInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerCoursePackageInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackageid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCpcategory();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getBegincpid();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getCpname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCpdescription();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLname();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getRoutenum();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getCreatedtime();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional int32 packageId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getPackageid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 lId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getLid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setLid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 mapId = 3;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 totalControlNum = 4;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 cpCategory = 5;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getCpcategory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setCpcategory = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 beginCpId = 6;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getBegincpid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setBegincpid = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string cpName = 7;
 * @return {string}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getCpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setCpname = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string cpDescription = 8;
 * @return {string}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getCpdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setCpdescription = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string lName = 12;
 * @return {string}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getLname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setLname = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string mapName = 13;
 * @return {string}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 status = 14;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 routeNum = 15;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getRoutenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setRoutenum = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string createdTime = 16;
 * @return {string}
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.getCreatedtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerCoursePackageInfo} returns this
 */
proto.manager.v1.ManagerCoursePackageInfo.prototype.setCreatedtime = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerCoursePackageAddRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerCoursePackageAddRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerCoursePackageAddRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 2, 0),
cpcategory: jspb.Message.getFieldWithDefault(msg, 3, 0),
begincpid: jspb.Message.getFieldWithDefault(msg, 4, 0),
cpname: jspb.Message.getFieldWithDefault(msg, 5, ""),
cpdescription: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerCoursePackageAddRequest}
 */
proto.manager.v1.ManagerCoursePackageAddRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerCoursePackageAddRequest;
  return proto.manager.v1.ManagerCoursePackageAddRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerCoursePackageAddRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerCoursePackageAddRequest}
 */
proto.manager.v1.ManagerCoursePackageAddRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCpcategory(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBegincpid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCpname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCpdescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerCoursePackageAddRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerCoursePackageAddRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerCoursePackageAddRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCpcategory();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getBegincpid();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCpname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCpdescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageAddRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 totalControlNum = 2;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageAddRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 cpCategory = 3;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.getCpcategory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageAddRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.setCpcategory = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 beginCpId = 4;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.getBegincpid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageAddRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.setBegincpid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string cpName = 5;
 * @return {string}
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.getCpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerCoursePackageAddRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.setCpname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string cpDescription = 6;
 * @return {string}
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.getCpdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerCoursePackageAddRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageAddRequest.prototype.setCpdescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerCoursePackageEditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerCoursePackageEditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerCoursePackageEditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
packageid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapid: jspb.Message.getFieldWithDefault(msg, 2, 0),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 3, 0),
cpcategory: jspb.Message.getFieldWithDefault(msg, 4, 0),
begincpid: jspb.Message.getFieldWithDefault(msg, 5, 0),
cpname: jspb.Message.getFieldWithDefault(msg, 6, ""),
cpdescription: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerCoursePackageEditRequest}
 */
proto.manager.v1.ManagerCoursePackageEditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerCoursePackageEditRequest;
  return proto.manager.v1.ManagerCoursePackageEditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerCoursePackageEditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerCoursePackageEditRequest}
 */
proto.manager.v1.ManagerCoursePackageEditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPackageid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCpcategory(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBegincpid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCpname(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCpdescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerCoursePackageEditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerCoursePackageEditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerCoursePackageEditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackageid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCpcategory();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getBegincpid();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getCpname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCpdescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional int32 packageId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.getPackageid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageEditRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 mapId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageEditRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 totalControlNum = 3;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageEditRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 cpCategory = 4;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.getCpcategory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageEditRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.setCpcategory = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 beginCpId = 5;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.getBegincpid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageEditRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.setBegincpid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string cpName = 6;
 * @return {string}
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.getCpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerCoursePackageEditRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.setCpname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string cpDescription = 7;
 * @return {string}
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.getCpdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerCoursePackageEditRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageEditRequest.prototype.setCpdescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerCoursePackageRelationRouteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
packageid: jspb.Message.getFieldWithDefault(msg, 1, 0),
cidarrList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest}
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerCoursePackageRelationRouteRequest;
  return proto.manager.v1.ManagerCoursePackageRelationRouteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest}
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPackageid(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCidarr(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerCoursePackageRelationRouteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackageid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCidarrList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 packageId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.prototype.getPackageid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated int32 cIdArr = 2;
 * @return {!Array<number>}
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.prototype.getCidarrList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.prototype.setCidarrList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.prototype.addCidarr = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} returns this
 */
proto.manager.v1.ManagerCoursePackageRelationRouteRequest.prototype.clearCidarrList = function() {
  return this.setCidarrList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.GenVerifyPicRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.GenVerifyPicRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.GenVerifyPicRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.GenVerifyPicRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
height: jspb.Message.getFieldWithDefault(msg, 1, 0),
width: jspb.Message.getFieldWithDefault(msg, 2, 0),
noisecount: jspb.Message.getFieldWithDefault(msg, 3, 0),
length: jspb.Message.getFieldWithDefault(msg, 4, 0),
source: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.GenVerifyPicRequest}
 */
proto.manager.v1.GenVerifyPicRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.GenVerifyPicRequest;
  return proto.manager.v1.GenVerifyPicRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.GenVerifyPicRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.GenVerifyPicRequest}
 */
proto.manager.v1.GenVerifyPicRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeight(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidth(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNoisecount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLength(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.GenVerifyPicRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.GenVerifyPicRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.GenVerifyPicRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.GenVerifyPicRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getNoisecount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLength();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 height = 1;
 * @return {number}
 */
proto.manager.v1.GenVerifyPicRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.GenVerifyPicRequest} returns this
 */
proto.manager.v1.GenVerifyPicRequest.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 width = 2;
 * @return {number}
 */
proto.manager.v1.GenVerifyPicRequest.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.GenVerifyPicRequest} returns this
 */
proto.manager.v1.GenVerifyPicRequest.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 noiseCount = 3;
 * @return {number}
 */
proto.manager.v1.GenVerifyPicRequest.prototype.getNoisecount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.GenVerifyPicRequest} returns this
 */
proto.manager.v1.GenVerifyPicRequest.prototype.setNoisecount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 length = 4;
 * @return {number}
 */
proto.manager.v1.GenVerifyPicRequest.prototype.getLength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.GenVerifyPicRequest} returns this
 */
proto.manager.v1.GenVerifyPicRequest.prototype.setLength = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string source = 5;
 * @return {string}
 */
proto.manager.v1.GenVerifyPicRequest.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.GenVerifyPicRequest} returns this
 */
proto.manager.v1.GenVerifyPicRequest.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.StdRsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.StdRsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.StdRsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.StdRsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
jsonstr: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.StdRsReply}
 */
proto.manager.v1.StdRsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.StdRsReply;
  return proto.manager.v1.StdRsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.StdRsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.StdRsReply}
 */
proto.manager.v1.StdRsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJsonstr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.StdRsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.StdRsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.StdRsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.StdRsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJsonstr();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string JsonStr = 1;
 * @return {string}
 */
proto.manager.v1.StdRsReply.prototype.getJsonstr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.StdRsReply} returns this
 */
proto.manager.v1.StdRsReply.prototype.setJsonstr = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerOiListQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerOiListQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerOiListQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerOiListQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
oiname: jspb.Message.getFieldWithDefault(msg, 3, ""),
page: jspb.Message.getFieldWithDefault(msg, 5, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerOiListQueryRequest}
 */
proto.manager.v1.ManagerOiListQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerOiListQueryRequest;
  return proto.manager.v1.ManagerOiListQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerOiListQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerOiListQueryRequest}
 */
proto.manager.v1.ManagerOiListQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOiname(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerOiListQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerOiListQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerOiListQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerOiListQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOiname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string oiName = 3;
 * @return {string}
 */
proto.manager.v1.ManagerOiListQueryRequest.prototype.getOiname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerOiListQueryRequest} returns this
 */
proto.manager.v1.ManagerOiListQueryRequest.prototype.setOiname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page = 5;
 * @return {number}
 */
proto.manager.v1.ManagerOiListQueryRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerOiListQueryRequest} returns this
 */
proto.manager.v1.ManagerOiListQueryRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 tableMax = 6;
 * @return {number}
 */
proto.manager.v1.ManagerOiListQueryRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerOiListQueryRequest} returns this
 */
proto.manager.v1.ManagerOiListQueryRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerOiInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerOiInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerOiInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerOiInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
oiid: jspb.Message.getFieldWithDefault(msg, 1, 0),
oiname: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerOiInfo}
 */
proto.manager.v1.ManagerOiInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerOiInfo;
  return proto.manager.v1.ManagerOiInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerOiInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerOiInfo}
 */
proto.manager.v1.ManagerOiInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOiid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOiname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerOiInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerOiInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerOiInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerOiInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOiid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getOiname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 oiId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerOiInfo.prototype.getOiid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerOiInfo} returns this
 */
proto.manager.v1.ManagerOiInfo.prototype.setOiid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string oiName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerOiInfo.prototype.getOiname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerOiInfo} returns this
 */
proto.manager.v1.ManagerOiInfo.prototype.setOiname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 status = 3;
 * @return {number}
 */
proto.manager.v1.ManagerOiInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerOiInfo} returns this
 */
proto.manager.v1.ManagerOiInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerActiveListQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerActiveListQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveListQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
planid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapid: jspb.Message.getFieldWithDefault(msg, 2, 0),
activename: jspb.Message.getFieldWithDefault(msg, 3, ""),
page: jspb.Message.getFieldWithDefault(msg, 5, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 6, 0),
matchtype: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerActiveListQueryRequest}
 */
proto.manager.v1.ManagerActiveListQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerActiveListQueryRequest;
  return proto.manager.v1.ManagerActiveListQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerActiveListQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerActiveListQueryRequest}
 */
proto.manager.v1.ManagerActiveListQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlanid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivename(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMatchtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerActiveListQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerActiveListQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveListQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlanid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getActivename();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMatchtype();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int32 planId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.getPlanid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveListQueryRequest} returns this
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.setPlanid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 mapId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveListQueryRequest} returns this
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string activeName = 3;
 * @return {string}
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.getActivename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveListQueryRequest} returns this
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.setActivename = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page = 5;
 * @return {number}
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveListQueryRequest} returns this
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 tableMax = 6;
 * @return {number}
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveListQueryRequest} returns this
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 matchType = 7;
 * @return {number}
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.getMatchtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveListQueryRequest} returns this
 */
proto.manager.v1.ManagerActiveListQueryRequest.prototype.setMatchtype = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerActiveRuleListQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerActiveRuleListQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerActiveRuleListQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveRuleListQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
actid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerActiveRuleListQueryRequest}
 */
proto.manager.v1.ManagerActiveRuleListQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerActiveRuleListQueryRequest;
  return proto.manager.v1.ManagerActiveRuleListQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerActiveRuleListQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerActiveRuleListQueryRequest}
 */
proto.manager.v1.ManagerActiveRuleListQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerActiveRuleListQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerActiveRuleListQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerActiveRuleListQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveRuleListQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 actId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerActiveRuleListQueryRequest.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveRuleListQueryRequest} returns this
 */
proto.manager.v1.ManagerActiveRuleListQueryRequest.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerActiveRuleInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerActiveRuleInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveRuleInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
arrid: jspb.Message.getFieldWithDefault(msg, 1, 0),
actid: jspb.Message.getFieldWithDefault(msg, 2, 0),
artype: jspb.Message.getFieldWithDefault(msg, 3, 0),
arvalue: jspb.Message.getFieldWithDefault(msg, 4, ""),
islock: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
arname: jspb.Message.getFieldWithDefault(msg, 6, ""),
memo: jspb.Message.getFieldWithDefault(msg, 7, ""),
tolock: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
toislockedit: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
toexclusive: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerActiveRuleInfo}
 */
proto.manager.v1.ManagerActiveRuleInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerActiveRuleInfo;
  return proto.manager.v1.ManagerActiveRuleInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerActiveRuleInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerActiveRuleInfo}
 */
proto.manager.v1.ManagerActiveRuleInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArrid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArtype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setArvalue(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIslock(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setArname(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemo(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTolock(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setToislockedit(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setToexclusive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerActiveRuleInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerActiveRuleInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveRuleInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArrid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getArtype();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getArvalue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIslock();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getArname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMemo();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTolock();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getToislockedit();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getToexclusive();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional int32 arrId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.getArrid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveRuleInfo} returns this
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.setArrid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 actId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveRuleInfo} returns this
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 arType = 3;
 * @return {number}
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.getArtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveRuleInfo} returns this
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.setArtype = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string arValue = 4;
 * @return {string}
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.getArvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveRuleInfo} returns this
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.setArvalue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool isLock = 5;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.getIslock = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveRuleInfo} returns this
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.setIslock = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string arName = 6;
 * @return {string}
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.getArname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveRuleInfo} returns this
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.setArname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string memo = 7;
 * @return {string}
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.getMemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveRuleInfo} returns this
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.setMemo = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool toLock = 8;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.getTolock = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveRuleInfo} returns this
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.setTolock = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool toIsLockEdit = 9;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.getToislockedit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveRuleInfo} returns this
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.setToislockedit = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool toExclusive = 10;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.getToexclusive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveRuleInfo} returns this
 */
proto.manager.v1.ManagerActiveRuleInfo.prototype.setToexclusive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerActiveInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerActiveInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerActiveInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
actid: jspb.Message.getFieldWithDefault(msg, 1, 0),
pid: jspb.Message.getFieldWithDefault(msg, 2, 0),
actname: jspb.Message.getFieldWithDefault(msg, 3, ""),
logourl: jspb.Message.getFieldWithDefault(msg, 4, ""),
descurl: jspb.Message.getFieldWithDefault(msg, 5, ""),
mapname: jspb.Message.getFieldWithDefault(msg, 6, ""),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 7, 0),
isopen: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
isrecommend: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
ordernum: jspb.Message.getFieldWithDefault(msg, 10, 0),
ronum: jspb.Message.getFieldWithDefault(msg, 11, 0),
oiid: jspb.Message.getFieldWithDefault(msg, 12, 0),
oiname: jspb.Message.getFieldWithDefault(msg, 13, ""),
packageid: jspb.Message.getFieldWithDefault(msg, 14, 0),
packagename: jspb.Message.getFieldWithDefault(msg, 15, ""),
status: jspb.Message.getFieldWithDefault(msg, 16, 0),
lockup: jspb.Message.getFieldWithDefault(msg, 17, 0),
forcedendtime: jspb.Message.getFieldWithDefault(msg, 18, 0),
racetype: jspb.Message.getFieldWithDefault(msg, 19, 0),
difficulty: jspb.Message.getFieldWithDefault(msg, 20, 0),
pname: jspb.Message.getFieldWithDefault(msg, 21, ""),
actdescription: jspb.Message.getFieldWithDefault(msg, 22, ""),
mapid: jspb.Message.getFieldWithDefault(msg, 23, 0),
createdtime: jspb.Message.getFieldWithDefault(msg, 24, ""),
matchtype: jspb.Message.getFieldWithDefault(msg, 25, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerActiveInfo}
 */
proto.manager.v1.ManagerActiveInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerActiveInfo;
  return proto.manager.v1.ManagerActiveInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerActiveInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerActiveInfo}
 */
proto.manager.v1.ManagerActiveInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogourl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescurl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsopen(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsrecommend(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdernum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRonum(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOiid(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setOiname(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPackageid(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackagename(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLockup(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setForcedendtime(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRacetype(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDifficulty(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setPname(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setActdescription(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedtime(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMatchtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerActiveInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerActiveInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerActiveInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getActname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLogourl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescurl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getIsopen();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getIsrecommend();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getOrdernum();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getRonum();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getOiid();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getOiname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPackageid();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getPackagename();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getLockup();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getForcedendtime();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getRacetype();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getDifficulty();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getPname();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getActdescription();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      23,
      f
    );
  }
  f = message.getCreatedtime();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getMatchtype();
  if (f !== 0) {
    writer.writeInt32(
      25,
      f
    );
  }
};


/**
 * optional int32 actId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 pId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getPid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setPid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string actName = 3;
 * @return {string}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getActname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setActname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string logoUrl = 4;
 * @return {string}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getLogourl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setLogourl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string descUrl = 5;
 * @return {string}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getDescurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setDescurl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string mapName = 6;
 * @return {string}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 totalControlNum = 7;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool isOpen = 8;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getIsopen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setIsopen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool isRecommend = 9;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getIsrecommend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setIsrecommend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional int32 orderNum = 10;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getOrdernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setOrdernum = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 roNum = 11;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getRonum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setRonum = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 oiId = 12;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getOiid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setOiid = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string oiName = 13;
 * @return {string}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getOiname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setOiname = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 packageId = 14;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getPackageid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string packageName = 15;
 * @return {string}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getPackagename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setPackagename = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int32 status = 16;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 lockup = 17;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getLockup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setLockup = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int32 forcedEndTime = 18;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getForcedendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setForcedendtime = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int32 raceType = 19;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getRacetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setRacetype = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int32 difficulty = 20;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getDifficulty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional string pName = 21;
 * @return {string}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getPname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setPname = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string actDescription = 22;
 * @return {string}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getActdescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setActdescription = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional int32 mapId = 23;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional string createdTime = 24;
 * @return {string}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getCreatedtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setCreatedtime = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional int32 matchType = 25;
 * @return {number}
 */
proto.manager.v1.ManagerActiveInfo.prototype.getMatchtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveInfo} returns this
 */
proto.manager.v1.ManagerActiveInfo.prototype.setMatchtype = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerActiveRule.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerActiveRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerActiveRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveRule.toObject = function(includeInstance, msg) {
  var f, obj = {
actid: jspb.Message.getFieldWithDefault(msg, 1, 0),
arrid: jspb.Message.getFieldWithDefault(msg, 2, 0),
arrname: jspb.Message.getFieldWithDefault(msg, 3, ""),
arrtype: jspb.Message.getFieldWithDefault(msg, 4, 0),
arrvaluestr: jspb.Message.getFieldWithDefault(msg, 5, ""),
islock: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerActiveRule}
 */
proto.manager.v1.ManagerActiveRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerActiveRule;
  return proto.manager.v1.ManagerActiveRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerActiveRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerActiveRule}
 */
proto.manager.v1.ManagerActiveRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArrid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setArrname(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArrtype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setArrvaluestr(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIslock(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerActiveRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerActiveRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerActiveRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getArrid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getArrname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getArrtype();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getArrvaluestr();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIslock();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional int32 actId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerActiveRule.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveRule} returns this
 */
proto.manager.v1.ManagerActiveRule.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 arrId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerActiveRule.prototype.getArrid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveRule} returns this
 */
proto.manager.v1.ManagerActiveRule.prototype.setArrid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string arrName = 3;
 * @return {string}
 */
proto.manager.v1.ManagerActiveRule.prototype.getArrname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveRule} returns this
 */
proto.manager.v1.ManagerActiveRule.prototype.setArrname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 arrType = 4;
 * @return {number}
 */
proto.manager.v1.ManagerActiveRule.prototype.getArrtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveRule} returns this
 */
proto.manager.v1.ManagerActiveRule.prototype.setArrtype = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string arrValueStr = 5;
 * @return {string}
 */
proto.manager.v1.ManagerActiveRule.prototype.getArrvaluestr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveRule} returns this
 */
proto.manager.v1.ManagerActiveRule.prototype.setArrvaluestr = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool isLock = 6;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveRule.prototype.getIslock = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveRule} returns this
 */
proto.manager.v1.ManagerActiveRule.prototype.setIslock = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerActiveAddRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerActiveAddRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveAddRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pid: jspb.Message.getFieldWithDefault(msg, 1, 0),
actname: jspb.Message.getFieldWithDefault(msg, 2, ""),
isopen: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
isrecommend: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
ordernum: jspb.Message.getFieldWithDefault(msg, 5, 0),
ronum: jspb.Message.getFieldWithDefault(msg, 6, 0),
oiid: jspb.Message.getFieldWithDefault(msg, 7, 0),
packageid: jspb.Message.getFieldWithDefault(msg, 8, 0),
logopicdata: (f = msg.getLogopicdata()) && base_pb.Image.toObject(includeInstance, f),
descpicdata: (f = msg.getDescpicdata()) && base_pb.Image.toObject(includeInstance, f),
actdesc: jspb.Message.getFieldWithDefault(msg, 11, ""),
matchtype: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerActiveAddRequest}
 */
proto.manager.v1.ManagerActiveAddRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerActiveAddRequest;
  return proto.manager.v1.ManagerActiveAddRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerActiveAddRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerActiveAddRequest}
 */
proto.manager.v1.ManagerActiveAddRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setActname(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsopen(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsrecommend(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdernum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRonum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOiid(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPackageid(value);
      break;
    case 9:
      var value = new base_pb.Image;
      reader.readMessage(value,base_pb.Image.deserializeBinaryFromReader);
      msg.setLogopicdata(value);
      break;
    case 10:
      var value = new base_pb.Image;
      reader.readMessage(value,base_pb.Image.deserializeBinaryFromReader);
      msg.setDescpicdata(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setActdesc(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMatchtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerActiveAddRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerActiveAddRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveAddRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getActname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsopen();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIsrecommend();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getOrdernum();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getRonum();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getOiid();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPackageid();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getLogopicdata();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      base_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getDescpicdata();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      base_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getActdesc();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getMatchtype();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
};


/**
 * optional int32 pId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.getPid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.setPid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string actName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.getActname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.setActname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool isOpen = 3;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.getIsopen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.setIsopen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool isRecommend = 4;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.getIsrecommend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.setIsrecommend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int32 orderNum = 5;
 * @return {number}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.getOrdernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.setOrdernum = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 roNum = 6;
 * @return {number}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.getRonum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.setRonum = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 oiId = 7;
 * @return {number}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.getOiid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.setOiid = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 packageId = 8;
 * @return {number}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.getPackageid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional base.v1.Image logoPicData = 9;
 * @return {?proto.base.v1.Image}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.getLogopicdata = function() {
  return /** @type{?proto.base.v1.Image} */ (
    jspb.Message.getWrapperField(this, base_pb.Image, 9));
};


/**
 * @param {?proto.base.v1.Image|undefined} value
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
*/
proto.manager.v1.ManagerActiveAddRequest.prototype.setLogopicdata = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.clearLogopicdata = function() {
  return this.setLogopicdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.hasLogopicdata = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional base.v1.Image descPicData = 10;
 * @return {?proto.base.v1.Image}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.getDescpicdata = function() {
  return /** @type{?proto.base.v1.Image} */ (
    jspb.Message.getWrapperField(this, base_pb.Image, 10));
};


/**
 * @param {?proto.base.v1.Image|undefined} value
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
*/
proto.manager.v1.ManagerActiveAddRequest.prototype.setDescpicdata = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.clearDescpicdata = function() {
  return this.setDescpicdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.hasDescpicdata = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string actDesc = 11;
 * @return {string}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.getActdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.setActdesc = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int32 matchType = 12;
 * @return {number}
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.getMatchtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveAddRequest} returns this
 */
proto.manager.v1.ManagerActiveAddRequest.prototype.setMatchtype = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerActiveEditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerActiveEditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveEditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
actid: jspb.Message.getFieldWithDefault(msg, 1, 0),
actname: jspb.Message.getFieldWithDefault(msg, 2, ""),
isopen: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
isrecommend: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
ordernum: jspb.Message.getFieldWithDefault(msg, 5, 0),
ronum: jspb.Message.getFieldWithDefault(msg, 6, 0),
oiid: jspb.Message.getFieldWithDefault(msg, 7, 0),
packageid: jspb.Message.getFieldWithDefault(msg, 8, 0),
logopicdata: (f = msg.getLogopicdata()) && base_pb.Image.toObject(includeInstance, f),
descpicdata: (f = msg.getDescpicdata()) && base_pb.Image.toObject(includeInstance, f),
lockup: jspb.Message.getFieldWithDefault(msg, 11, 0),
forcedendtime: jspb.Message.getFieldWithDefault(msg, 12, 0),
racetype: jspb.Message.getFieldWithDefault(msg, 13, 0),
difficulty: jspb.Message.getFieldWithDefault(msg, 14, 0),
actdesc: jspb.Message.getFieldWithDefault(msg, 15, ""),
matchtype: jspb.Message.getFieldWithDefault(msg, 16, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerActiveEditRequest}
 */
proto.manager.v1.ManagerActiveEditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerActiveEditRequest;
  return proto.manager.v1.ManagerActiveEditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerActiveEditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerActiveEditRequest}
 */
proto.manager.v1.ManagerActiveEditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setActname(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsopen(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsrecommend(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdernum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRonum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOiid(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPackageid(value);
      break;
    case 9:
      var value = new base_pb.Image;
      reader.readMessage(value,base_pb.Image.deserializeBinaryFromReader);
      msg.setLogopicdata(value);
      break;
    case 10:
      var value = new base_pb.Image;
      reader.readMessage(value,base_pb.Image.deserializeBinaryFromReader);
      msg.setDescpicdata(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLockup(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setForcedendtime(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRacetype(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDifficulty(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setActdesc(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMatchtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerActiveEditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerActiveEditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerActiveEditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getActname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsopen();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIsrecommend();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getOrdernum();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getRonum();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getOiid();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPackageid();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getLogopicdata();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      base_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getDescpicdata();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      base_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getLockup();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getForcedendtime();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getRacetype();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getDifficulty();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getActdesc();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getMatchtype();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
};


/**
 * optional int32 actId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string actName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getActname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setActname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool isOpen = 3;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getIsopen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setIsopen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool isRecommend = 4;
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getIsrecommend = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setIsrecommend = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int32 orderNum = 5;
 * @return {number}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getOrdernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setOrdernum = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 roNum = 6;
 * @return {number}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getRonum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setRonum = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 oiId = 7;
 * @return {number}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getOiid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setOiid = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 packageId = 8;
 * @return {number}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getPackageid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional base.v1.Image logoPicData = 9;
 * @return {?proto.base.v1.Image}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getLogopicdata = function() {
  return /** @type{?proto.base.v1.Image} */ (
    jspb.Message.getWrapperField(this, base_pb.Image, 9));
};


/**
 * @param {?proto.base.v1.Image|undefined} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
*/
proto.manager.v1.ManagerActiveEditRequest.prototype.setLogopicdata = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.clearLogopicdata = function() {
  return this.setLogopicdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.hasLogopicdata = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional base.v1.Image descPicData = 10;
 * @return {?proto.base.v1.Image}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getDescpicdata = function() {
  return /** @type{?proto.base.v1.Image} */ (
    jspb.Message.getWrapperField(this, base_pb.Image, 10));
};


/**
 * @param {?proto.base.v1.Image|undefined} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
*/
proto.manager.v1.ManagerActiveEditRequest.prototype.setDescpicdata = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.clearDescpicdata = function() {
  return this.setDescpicdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.hasDescpicdata = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional int32 lockup = 11;
 * @return {number}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getLockup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setLockup = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 forcedEndTime = 12;
 * @return {number}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getForcedendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setForcedendtime = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 raceType = 13;
 * @return {number}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getRacetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setRacetype = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 difficulty = 14;
 * @return {number}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getDifficulty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional string actDesc = 15;
 * @return {string}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getActdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setActdesc = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int32 matchType = 16;
 * @return {number}
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.getMatchtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerActiveEditRequest} returns this
 */
proto.manager.v1.ManagerActiveEditRequest.prototype.setMatchtype = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerPlanListQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerPlanListQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerPlanListQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanListQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
planname: jspb.Message.getFieldWithDefault(msg, 2, ""),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
tablemax: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerPlanListQueryRequest}
 */
proto.manager.v1.ManagerPlanListQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerPlanListQueryRequest;
  return proto.manager.v1.ManagerPlanListQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerPlanListQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerPlanListQueryRequest}
 */
proto.manager.v1.ManagerPlanListQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTablemax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerPlanListQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerPlanListQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerPlanListQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanListQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPlanname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTablemax();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerPlanListQueryRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanListQueryRequest} returns this
 */
proto.manager.v1.ManagerPlanListQueryRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string planName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerPlanListQueryRequest.prototype.getPlanname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanListQueryRequest} returns this
 */
proto.manager.v1.ManagerPlanListQueryRequest.prototype.setPlanname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.manager.v1.ManagerPlanListQueryRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanListQueryRequest} returns this
 */
proto.manager.v1.ManagerPlanListQueryRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 tableMax = 4;
 * @return {number}
 */
proto.manager.v1.ManagerPlanListQueryRequest.prototype.getTablemax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanListQueryRequest} returns this
 */
proto.manager.v1.ManagerPlanListQueryRequest.prototype.setTablemax = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.manager.v1.ManagerPlanInfo.repeatedFields_ = [13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerPlanInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerPlanInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerPlanInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
planid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapid: jspb.Message.getFieldWithDefault(msg, 2, 0),
planname: jspb.Message.getFieldWithDefault(msg, 3, ""),
lockup: jspb.Message.getFieldWithDefault(msg, 4, 0),
forcedendtime: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 6, 0),
mapname: jspb.Message.getFieldWithDefault(msg, 7, ""),
status: jspb.Message.getFieldWithDefault(msg, 8, 0),
difficulty: jspb.Message.getFieldWithDefault(msg, 9, 0),
racetype: jspb.Message.getFieldWithDefault(msg, 10, 0),
plandescription: jspb.Message.getFieldWithDefault(msg, 11, ""),
createdtime: jspb.Message.getFieldWithDefault(msg, 12, ""),
packageidarrList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerPlanInfo}
 */
proto.manager.v1.ManagerPlanInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerPlanInfo;
  return proto.manager.v1.ManagerPlanInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerPlanInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerPlanInfo}
 */
proto.manager.v1.ManagerPlanInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlanid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanname(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLockup(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setForcedendtime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDifficulty(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRacetype(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlandescription(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedtime(value);
      break;
    case 13:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPackageidarr(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerPlanInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerPlanInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerPlanInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlanid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPlanname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLockup();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getForcedendtime();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getDifficulty();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getRacetype();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getPlandescription();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCreatedtime();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPackageidarrList();
  if (f.length > 0) {
    writer.writePackedInt32(
      13,
      f
    );
  }
};


/**
 * optional int32 planId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getPlanid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setPlanid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 mapId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string planName = 3;
 * @return {string}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getPlanname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setPlanname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 lockup = 4;
 * @return {number}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getLockup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setLockup = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 forcedEndTime = 5;
 * @return {number}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getForcedendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setForcedendtime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 totalControlNum = 6;
 * @return {number}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string mapName = 7;
 * @return {string}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 status = 8;
 * @return {number}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 difficulty = 9;
 * @return {number}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getDifficulty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 raceType = 10;
 * @return {number}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getRacetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setRacetype = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string planDescription = 11;
 * @return {string}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getPlandescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setPlandescription = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string createdTime = 12;
 * @return {string}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getCreatedtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setCreatedtime = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated int32 packageIdArr = 13;
 * @return {!Array<number>}
 */
proto.manager.v1.ManagerPlanInfo.prototype.getPackageidarrList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.setPackageidarrList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.addPackageidarr = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.manager.v1.ManagerPlanInfo} returns this
 */
proto.manager.v1.ManagerPlanInfo.prototype.clearPackageidarrList = function() {
  return this.setPackageidarrList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerPlanSimpleInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerPlanSimpleInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanSimpleInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
planid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapid: jspb.Message.getFieldWithDefault(msg, 2, 0),
planname: jspb.Message.getFieldWithDefault(msg, 3, ""),
lockup: jspb.Message.getFieldWithDefault(msg, 4, 0),
forcedendtime: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 6, 0),
mapname: jspb.Message.getFieldWithDefault(msg, 7, ""),
status: jspb.Message.getFieldWithDefault(msg, 8, 0),
difficulty: jspb.Message.getFieldWithDefault(msg, 9, 0),
racetype: jspb.Message.getFieldWithDefault(msg, 10, 0),
plandescription: jspb.Message.getFieldWithDefault(msg, 11, ""),
createdtime: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo}
 */
proto.manager.v1.ManagerPlanSimpleInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerPlanSimpleInfo;
  return proto.manager.v1.ManagerPlanSimpleInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerPlanSimpleInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo}
 */
proto.manager.v1.ManagerPlanSimpleInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlanid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanname(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLockup(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setForcedendtime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDifficulty(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRacetype(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlandescription(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerPlanSimpleInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerPlanSimpleInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanSimpleInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlanid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPlanname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLockup();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getForcedendtime();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getDifficulty();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getRacetype();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getPlandescription();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCreatedtime();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional int32 planId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.getPlanid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo} returns this
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.setPlanid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 mapId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo} returns this
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string planName = 3;
 * @return {string}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.getPlanname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo} returns this
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.setPlanname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 lockup = 4;
 * @return {number}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.getLockup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo} returns this
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.setLockup = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 forcedEndTime = 5;
 * @return {number}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.getForcedendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo} returns this
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.setForcedendtime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 totalControlNum = 6;
 * @return {number}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo} returns this
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string mapName = 7;
 * @return {string}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo} returns this
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 status = 8;
 * @return {number}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo} returns this
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 difficulty = 9;
 * @return {number}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.getDifficulty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo} returns this
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 raceType = 10;
 * @return {number}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.getRacetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo} returns this
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.setRacetype = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string planDescription = 11;
 * @return {string}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.getPlandescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo} returns this
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.setPlandescription = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string createdTime = 12;
 * @return {string}
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.getCreatedtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanSimpleInfo} returns this
 */
proto.manager.v1.ManagerPlanSimpleInfo.prototype.setCreatedtime = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.manager.v1.ManagerPlanAddRequest.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerPlanAddRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerPlanAddRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanAddRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
planname: jspb.Message.getFieldWithDefault(msg, 2, ""),
lockup: jspb.Message.getFieldWithDefault(msg, 3, 0),
forcedendtime: jspb.Message.getFieldWithDefault(msg, 4, 0),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 5, 0),
racetype: jspb.Message.getFieldWithDefault(msg, 6, 0),
difficulty: jspb.Message.getFieldWithDefault(msg, 7, 0),
plandescription: jspb.Message.getFieldWithDefault(msg, 8, ""),
packageidarrList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerPlanAddRequest}
 */
proto.manager.v1.ManagerPlanAddRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerPlanAddRequest;
  return proto.manager.v1.ManagerPlanAddRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerPlanAddRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerPlanAddRequest}
 */
proto.manager.v1.ManagerPlanAddRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLockup(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setForcedendtime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRacetype(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDifficulty(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlandescription(value);
      break;
    case 9:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPackageidarr(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerPlanAddRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerPlanAddRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanAddRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPlanname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLockup();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getForcedendtime();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getRacetype();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getDifficulty();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPlandescription();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPackageidarrList();
  if (f.length > 0) {
    writer.writePackedInt32(
      9,
      f
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanAddRequest} returns this
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string planName = 2;
 * @return {string}
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.getPlanname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanAddRequest} returns this
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.setPlanname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 lockup = 3;
 * @return {number}
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.getLockup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanAddRequest} returns this
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.setLockup = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 forcedEndTime = 4;
 * @return {number}
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.getForcedendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanAddRequest} returns this
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.setForcedendtime = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 totalControlNum = 5;
 * @return {number}
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanAddRequest} returns this
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 raceType = 6;
 * @return {number}
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.getRacetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanAddRequest} returns this
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.setRacetype = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 difficulty = 7;
 * @return {number}
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.getDifficulty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanAddRequest} returns this
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string planDescription = 8;
 * @return {string}
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.getPlandescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanAddRequest} returns this
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.setPlandescription = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated int32 packageIdArr = 9;
 * @return {!Array<number>}
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.getPackageidarrList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.manager.v1.ManagerPlanAddRequest} returns this
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.setPackageidarrList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.manager.v1.ManagerPlanAddRequest} returns this
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.addPackageidarr = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.manager.v1.ManagerPlanAddRequest} returns this
 */
proto.manager.v1.ManagerPlanAddRequest.prototype.clearPackageidarrList = function() {
  return this.setPackageidarrList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.manager.v1.ManagerPlanEditRequest.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerPlanEditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerPlanEditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanEditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
planid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapid: jspb.Message.getFieldWithDefault(msg, 2, 0),
planname: jspb.Message.getFieldWithDefault(msg, 3, ""),
lockup: jspb.Message.getFieldWithDefault(msg, 4, 0),
forcedendtime: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 6, 0),
racetype: jspb.Message.getFieldWithDefault(msg, 7, 0),
difficulty: jspb.Message.getFieldWithDefault(msg, 8, 0),
plandescription: jspb.Message.getFieldWithDefault(msg, 9, ""),
packageidarrList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerPlanEditRequest}
 */
proto.manager.v1.ManagerPlanEditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerPlanEditRequest;
  return proto.manager.v1.ManagerPlanEditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerPlanEditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerPlanEditRequest}
 */
proto.manager.v1.ManagerPlanEditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlanid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanname(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLockup(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setForcedendtime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRacetype(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDifficulty(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlandescription(value);
      break;
    case 10:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPackageidarr(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerPlanEditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerPlanEditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerPlanEditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlanid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPlanname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLockup();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getForcedendtime();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getRacetype();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getDifficulty();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getPlandescription();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPackageidarrList();
  if (f.length > 0) {
    writer.writePackedInt32(
      10,
      f
    );
  }
};


/**
 * optional int32 planId = 1;
 * @return {number}
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.getPlanid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanEditRequest} returns this
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.setPlanid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 mapId = 2;
 * @return {number}
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanEditRequest} returns this
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string planName = 3;
 * @return {string}
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.getPlanname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanEditRequest} returns this
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.setPlanname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 lockup = 4;
 * @return {number}
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.getLockup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanEditRequest} returns this
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.setLockup = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 forcedEndTime = 5;
 * @return {number}
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.getForcedendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanEditRequest} returns this
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.setForcedendtime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 totalControlNum = 6;
 * @return {number}
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanEditRequest} returns this
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 raceType = 7;
 * @return {number}
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.getRacetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanEditRequest} returns this
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.setRacetype = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 difficulty = 8;
 * @return {number}
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.getDifficulty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.manager.v1.ManagerPlanEditRequest} returns this
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string planDescription = 9;
 * @return {string}
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.getPlandescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerPlanEditRequest} returns this
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.setPlandescription = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated int32 packageIdArr = 10;
 * @return {!Array<number>}
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.getPackageidarrList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.manager.v1.ManagerPlanEditRequest} returns this
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.setPackageidarrList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.manager.v1.ManagerPlanEditRequest} returns this
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.addPackageidarr = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.manager.v1.ManagerPlanEditRequest} returns this
 */
proto.manager.v1.ManagerPlanEditRequest.prototype.clearPackageidarrList = function() {
  return this.setPackageidarrList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.GenVerifyPicReply.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.GenVerifyPicReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.GenVerifyPicReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.GenVerifyPicReply.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pic: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.GenVerifyPicReply}
 */
proto.manager.v1.GenVerifyPicReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.GenVerifyPicReply;
  return proto.manager.v1.GenVerifyPicReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.GenVerifyPicReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.GenVerifyPicReply}
 */
proto.manager.v1.GenVerifyPicReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPic(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.GenVerifyPicReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.GenVerifyPicReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.GenVerifyPicReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.GenVerifyPicReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPic();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.manager.v1.GenVerifyPicReply.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.GenVerifyPicReply} returns this
 */
proto.manager.v1.GenVerifyPicReply.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pic = 2;
 * @return {string}
 */
proto.manager.v1.GenVerifyPicReply.prototype.getPic = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.GenVerifyPicReply} returns this
 */
proto.manager.v1.GenVerifyPicReply.prototype.setPic = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.manager.v1.ManagerSignInRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.manager.v1.ManagerSignInRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.manager.v1.ManagerSignInRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerSignInRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
usercode: jspb.Message.getFieldWithDefault(msg, 1, ""),
password: jspb.Message.getFieldWithDefault(msg, 2, ""),
ip: jspb.Message.getFieldWithDefault(msg, 3, ""),
picid: jspb.Message.getFieldWithDefault(msg, 4, ""),
piccode: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manager.v1.ManagerSignInRequest}
 */
proto.manager.v1.ManagerSignInRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manager.v1.ManagerSignInRequest;
  return proto.manager.v1.ManagerSignInRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manager.v1.ManagerSignInRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manager.v1.ManagerSignInRequest}
 */
proto.manager.v1.ManagerSignInRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsercode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIp(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPicid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPiccode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.manager.v1.ManagerSignInRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.manager.v1.ManagerSignInRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manager.v1.ManagerSignInRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.manager.v1.ManagerSignInRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsercode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIp();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPicid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPiccode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string userCode = 1;
 * @return {string}
 */
proto.manager.v1.ManagerSignInRequest.prototype.getUsercode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerSignInRequest} returns this
 */
proto.manager.v1.ManagerSignInRequest.prototype.setUsercode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.manager.v1.ManagerSignInRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerSignInRequest} returns this
 */
proto.manager.v1.ManagerSignInRequest.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ip = 3;
 * @return {string}
 */
proto.manager.v1.ManagerSignInRequest.prototype.getIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerSignInRequest} returns this
 */
proto.manager.v1.ManagerSignInRequest.prototype.setIp = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string picId = 4;
 * @return {string}
 */
proto.manager.v1.ManagerSignInRequest.prototype.getPicid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerSignInRequest} returns this
 */
proto.manager.v1.ManagerSignInRequest.prototype.setPicid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string picCode = 5;
 * @return {string}
 */
proto.manager.v1.ManagerSignInRequest.prototype.getPiccode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.manager.v1.ManagerSignInRequest} returns this
 */
proto.manager.v1.ManagerSignInRequest.prototype.setPiccode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


goog.object.extend(exports, proto.manager.v1);
